import React, { useEffect, useRef, useState } from 'react';
import "@arcgis/core/assets/esri/themes/light/main.css";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";
import esriRequest from "@arcgis/core/request";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";
import Measurement from "@arcgis/core/widgets/Measurement";
//import '../styles/arcgis-widgets.css';
import "@arcgis/core/assets/esri/themes/light/main.css"; // ArcGIS theme
import * as XLSX from "xlsx";

import { FaHome, FaTint, FaWater, FaReceipt, FaUsers, FaBus, FaChartArea } from 'react-icons/fa';
import { useMemo } from 'react';
import { isNull } from 'lodash';

const tabItems = [
    { key: 'property', label: 'Property Info', icon: <FaHome className="mr-2" size={20} /> },
    { key: 'water', label: 'Water Supply', icon: <FaTint className="mr-2" size={20} /> },
    { key: 'sewerage', label: 'Sewerage N/W', icon: <FaWater className="mr-2" size={20} /> },
    { key: 'taxation', label: 'Taxation', icon: <FaReceipt className="mr-2" size={20} /> },
    { key: 'population', label: 'Population', icon: <FaUsers className="mr-2" size={20} /> },
    { key: 'transportation', label: 'Transportation', icon: <FaBus className="mr-2" size={20} /> },
    { key: 'ecosenstivearea', label: 'Ecosenstive Area', icon: <FaChartArea className="mr-2" size={20} /> },
];

const Prod_API = "https://mpurbangis.in";

// code for slider 
const mainLayerUrl = Prod_API + "/server/rest/services/temp_n/urbangis_temp/MapServer";

// GEO_1
const adminSublayers = [
    { id: 1, title: "MP State", visible: false },
    { id: 3, title: "MP District", visible: true },
    { id: 94, title: "MP ULB", visible: false },
    { id: 95, title: "MP Ward", visible: false },
    { id: 5, title: "Municipal Area", visible: false },
    { id: 7, title: "Municipal Ward", visible: false },
];

// GEO_2
const PROPERTY_URL = Prod_API + "/server/rest/services/temp_n/urbangis_temp/MapServer";

const PROPERTY_SUBLAYERS = [
    { id: 14, title: "Property", visible: true },
    { id: 15, title: "Building Footprint", visible: false },
    { id: 16, title: "Builtup Area", visible: false },
    { id: 17, title: "Slum Area", visible: false },
    { id: 39, title: "Industrial Area", visible: false },

];

// GEO_3
// 3OCT Transportation
const Transportation_URL = Prod_API + "/server/rest/services/temp_n/urbangis_temp/MapServer";
const Transportation_SUBLAYERS = [
    { id: 45, title: "Roads", visible: true },
    { id: 46, title: "Road Area", visible: false },
    { id: 64, title: "Bus Stand", visible: false },
    { id: 59, title: "Railway Station", visible: true },
    { id: 56, title: "Railway Line", visible: true },
    { id: 57, title: "Railway Area", visible: false },
    { id: 58, title: "Railway Property", visible: false },
];

// GEO_4

const WTRBWaterURL = Prod_API + "/server/rest/services/temp_n/urbangis_temp/MapServer";
//const WaterBodies_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";
const WTRBWaterURL_sublayer = [
    { id: 69, title: "Rivers", visible: false },
    { id: 70, title: "Drainage or Nala", visible: false },
    { id: 75, title: "Lake/Pond/Reservoir", visible: false }

];


// GEO_5
const WATER_URL = Prod_API + "/server/rest/services/temp_n/watersupply_project/MapServer";
const waterSublayers = [
    { id: 1, title: "WTP", visible: true },
    { id: 2, title: "Intake Well", visible: false },
    { id: 3, title: "OHT", visible: false },
    { id: 4, title: "Junction", visible: false },
    { id: 5, title: "RWPM", visible: false },
    { id: 6, title: "CWPM" },
    { id: 7, title: "Distribution Network", visible: true }
];

// GEO_6

// SEWER_URL
const SEWER_URL = Prod_API + "/server/rest/services/temp_n/sewerage_project/MapServer";
const SEWER_SUBLAYERS = [
    { id: 1, title: "STP", visible: false },
    { id: 2, title: "MPS", visible: false },
    { id: 3, title: "IPS", visible: false },
    { id: 4, title: "Manhole", visible: false },
    { id: 5, title: "Sewer Line", visible: true },
];


// GEO_7

const StormWaterURL = Prod_API + "/server/rest/services/temp_n/stormwater_project_data/MapServer";
const StormWaterURL_sublayer = [
    { id: 1, title: "Storm Water Drainage Line", visible: false },
];

// GEO_8
// AMRUT 2.0
const AMRUT_URL = Prod_API + "/server/rest/services/temp_n/amrut_scheme/MapServer";
const AMRUT_SUBLAYERS = [
    { id: 1, title: "Green Space Development", visible: false },
    { id: 2, title: "Waterbody Rejuvenation", visible: false },

];


// GEO_9

// Step :1  Master Plan 
const MASTER_PLAN_URL = Prod_API + "/server/rest/services/temp_n/master_plan/MapServer";
const MASTER_PLAN_SUBLAYERS = [
    { id: 1, title: "Planning Area" },
    { id: 2, title: "Master Plan Village Boundary" },
    { id: 3, title: "Master Plan" },
];


// GEO_10

const SAMPDA_GUIDELINE_URL = Prod_API + "/server/rest/services/temp_n/sampda_guideline/MapServer";
const SAMPDA_GUIDELINE_SUBLAYERS = [
    { id: 1, title: "Sampda Guideline 2025_26" },
];


// GEO_11
const Monuments_URL = Prod_API + "/server/rest/services/temp_n/monuments_site_data/MapServer";
const Monuments_SUBLAYERS = [
    { id: 1, title: "Monument Site ", visible: false },
    { id: 2, title: "Monument Area ", visible: false },
    { id: 3, title: "Protected Zone (0-100 M)", visible: false },
    { id: 4, title: "Regulated Zone (100-300 M)", visible: false },
];

// GEO_12


const AAI_URL = Prod_API + "/server/rest/services/temp_n/aai_cczm_grid/MapServer";
const AAI_SUBLAYERS = [
    { id: 1, title: "AAI CCZM Grid", visible: false },
];




// GEO_13
const HousingBoard_URL = Prod_API + "/server/rest/services/temp_n/mp_housing_board_colony/MapServer";
const HousingBoard_SUBLAYERS = [
    { id: 1, title: "Housing Board", visible: false },

];


// GEO_14

const BDA_URL = Prod_API + "/server/rest/services/temp_n/development_autorities_colony/MapServer";
const BDA_SUBLAYERS = [
    { id: 1, title: "Development Authorities", visible: false },
];

// GEO_15

const ASSETS_URL1 = Prod_API + "/server/rest/services/temp_n/govt_assets_mis/MapServer";
const ASSETS_Central_SUBLAYERS = [
    {
        id: 2, title: "Central Govt Assets", visible: false,

    },
    { id: 3, title: "State Govt Assets", visible: false },
    { id: 4, title: "Municipal Govt Assets", visible: false }
];

// GEO_16 SMB
//code for Swachh Bharat Mission
const SBM_URL1 = Prod_API + "/server/rest/services/temp_n/sbm_data/MapServer";
const SBM_SUBLAYERS = [
    { id: 1, title: "All Processing Plant", visible: false },
    { id: 2, title: "Dump Site", visible: false },
    { id: 3, title: "Landfill", visible: false },
    { id: 11, title: "Bio Methanation", visible: false },
    { id: 12, title: "C&D Waste Processing Facility", visible: false },
    { id: 13, title: "Faecal Sludge Treatment Plant (FSTP)", visible: false },
    { id: 14, title: "Material Recovery Facility (MRF)", visible: false },
    { id: 15, title: "STP", visible: false },
    { id: 16, title: "Waste To Compost", visible: false },
    { id: 17, title: "Waste To Energy", visible: false },

];



//  // GEO_17 SMBLANDUSE
const MPLanduse_URL = Prod_API + "/server/rest/services/temp_n/mp_lulc_change/MapServer";
const MPLanduse_sublayer = [
    { id: 6, title: "Landuse 2022", visible: false },
    { id: 8, title: "Landuse 2024", visible: false },
];



//  GEO_18 LandSuitability

const LandSuitabilityURL = Prod_API + "/server/rest/services/temp_n/land_suitability/MapServer";
const LandSuitabilityURL_sublayer = [
    { id: 2, title: "For Conservation", visible: false },
    { id: 3, title: "For Plantation", visible: false },

];



// GEO19 BHUPEN STEP1 Green Spaces
const GreenSpacesURL = Prod_API + "/server/rest/services/temp_n/urbangis_temp/MapServer";
const GreenSpacesURL_sublayer = [
    { id: 30, title: "Agricultural Area", visible: false },
    { id: 32, title: "Forest", visible: false },
    { id: 33, title: "Vacant Lands", visible: false },
    { id: 34, title: "Waste Lands", visible: false },
    { id: 36, title: "Open Land", visible: false },
    { id: 38, title: "Playground", visible: false },
    { id: 41, title: "Plantation", visible: false },
    { id: 42, title: "Orchyard", visible: false },
    { id: 43, title: "Park", visible: false },

];


//GEO20 CODE for BASE MAP
const ImportantLandmarksURL = Prod_API + "/server/rest/services/temp_n/urbangis_temp/MapServer";
const ImportantLandmarksURL_sublayer = [
   
    { id: 79, title: "Important Landmarks", visible: false, },
    { id: 98, title: "Stadium", visible: false, },
    { id: 99, title: "Police Station", visible: false, },

    

];


const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
const BaseMapURLURL_sublayer = [
    { id: 15, title: "Building Footprint", visible: false, },
    { id: 45, title: "Roads", visible: false, },
    { id: 56, title: "Railway", visible: false, },
    { id: 75, title: "Lake/Pond/Reservoir", visible: false, },
    { id: 79, title: "Important Landmarks", visible: false, },

];


// GEO21 BHUPEN STEP1 New Identified Colonies
const New_identified_coloniesURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/new_identified_colonies/MapServer";
const New_identified_coloniesURL_sublayer = [
    { id: 1, title: "New Identified Colonies", visible: false },
];


// GEO21 BHUPEN STEP1 smartcity_abd_area
const smartcity_abd_areaURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/smartcity_abd_area/MapServer";
const smartcity_abd_areaURL_sublayer = [
    { id: 1, title: "Smart City ABD ", visible: false },
];


// code for slider 
const MapGraphDashboad = ({
    selectedDistrict,
    selectedUlb,
    selectedWard,
    districtCode,
    ulbCode,
    wardCode,
    activeTabinfo, dist_cd, ulb_cd, wardno, isRightSide,
    selectedTitle, activeTabRef, activeSubTabCard
}) => {

    const mapDiv = useRef(null);
    //const layerRef = useRef(null);
    const [view, setView] = useState(null);
    //const [selectedTitle, setselectedTitle] = useState(selectedTitle || '0');
    // const [activeSubTabCard, setactiveSubTabCard] = useState('');
    const [activeTab, setActiveTab] = useState(activeTabinfo || 'total');

    const [popupVisible, setPopupVisible] = useState(false);
    const [UpopupVisible, setUPopupVisible] = useState(false);

    //22 NOV LAyer reference 

    const layerRef = useRef(null);        // water layer
    const secondLayerRef = useRef(null);  // admin layer
    const legendWidgetRef = useRef(null);
    const [adminLegends, setAdminLegends] = useState({});
    const PropertierLayerRef = useRef(null);
    const [PropertyLegends, setPropertyLegends] = useState({});



    const ASSETS_CentralLayerRef = useRef(null);
    const [ASSETS_CentralLegends, setASSETS_CentralLegends] = useState({});

    const SMBLayerRef = useRef(null);
    const [SBMLegends, setSMBLegends] = useState({});
    const AMRUTLayerRef = useRef(null);
    const [AMRUTLegends, setAMRUTLegends] = useState({});
    const WaterLayerRef = useRef(null);
    const [waterLegends, setWaterLegends] = useState({});
    const SEWRAGELayerRef = useRef(null);
    const [SEWRAGELegends, setSEWRAGELegends] = useState({});
    const TransportationLayerRef = useRef(null);
    const [TransportationLegends, setTransportationLegends] = useState({});
    const masterPlanLayerRef = useRef(null);
    const [masterPlanLegends, setMasterPlanLegends] = useState({});
    const sampdaGuidelineLayerRef = useRef(null);
    const [sampdaLegends, setSampdaLegends] = useState({});
    const BasemapLayerRef = useRef(null);
    const [BasemapLegends, setBasemapLegends] = useState({});

    //  code 12 DEC 2025
    const MPLanduseLayerRef = useRef(null);
    const [MPLanduseLegends, setMPLanduseLegends] = useState({});

    // LIVE
    const WTRBWaterURLLayerRef = useRef(null);
    const [WTRBWaterURLLegends, setWTRBWaterURLLegends] = useState({});
    const [showWTRBWater, setshowWTRBWater] = useState(false);

    const StormWaterURLLayerRef = useRef(null);
    const [StormWaterURLLegends, setStormWaterURLLegends] = useState({});
    const [showStromWater, setshowStromWater] = useState(false);



    const LandSuitabilityURLLayerRef = useRef(null);
    const [LandSuitabilityURLLegends, setLandSuitabilityURLLegends] = useState({});

    //BHUPEN STEP 2 
    const GreenSpacesURLLayerRef = useRef(null);
    const [GreenSpacesURLLegends, setGreenSpacesURLLegends] = useState({});
    const [showGreenSpaces, setshowGreenSpaces] = useState(false);
    //25MAY
    const AAILayerRef = useRef(null);
    const [AAILegends, setAAILegends] = useState({});
    const [showAAI, setshowAAI] = useState(false);

    // BHUEPEN STEP 2
    const MonumentsLayerRef = useRef(null);
    const [MonumentsLegends, setMonumentsLegends] = useState({});
    const [showMonuments, setshowMonuments] = useState(false);

    const HousingBoardLayerRef = useRef(null);
    const [HousingBoardLegends, setHousingBoardLegends] = useState({});
    const [showHousingBoard, setshowHousingBoard] = useState(false);

    const BDALayerRef = useRef(null);
    const [BDALegends, setBDALegends] = useState({});
    const [showBDA, setshowBDA] = useState(false);


    const New_identified_coloniesURLLayerRef = useRef(null);
    const [New_identified_coloniesURLLegends, setNew_identified_coloniesURLLegends] = useState({});
    const [showNew_identified_coloniesURL, setshowNew_identified_coloniesURL] = useState(false);


    const smartcity_abd_areaURLLayerRef = useRef(null);
    const [smartcity_abd_areaURLLegends, setsmartcity_abd_areaURLLegends] = useState({});
    const [showsmartcity_abd_areaURL, setshowsmartcity_abd_areaURL] = useState(false);

    const ImportantLandmarksURLLayerRef = useRef(null);
    const [ImportantLandmarksURLLegends, setImportantLandmarksURLLegends] = useState({});
    const [showImportantLandmarksURL, setshowImportantLandmarksURL] = useState(false);






    const [showAdmin, setshowAdmin] = useState(false);
    const [showProperties, setshowProperties] = useState(false);
    const [showMPLanduse, setShowMPLanduse] = useState(false);
    const [showLandSuitability, setshowLandSuitability] = useState(false);
    const [showGovernmentASSETS, setGovernmentASSETS] = useState(false);
    const [showSBM, setshowSBM] = useState(false);
    const [showAmrut, setshowAmrut] = useState(false);
    const [showWaterSupply, setshowWaterSupply] = useState(false);
    const [showSewerage, setshowSewerage] = useState(false);
    const [showTransportation, setshowTransportation] = useState(false);
    const [showMasterPlan, setshowMasterPlan] = useState(false);
    const [showSampdaGuideline, setshowSampdaGuideline] = useState(false);
    const [showBaseMap, setshowBaseMap] = useState(false);
    const [checkedLayers, setCheckedLayers] = useState({});


    const h4HeaderStyle = {
        margin: "16px 0 6px",
        color: "#0b0b0bff",
        background: "#cfd7deff",
        padding: "8px 12px",
        borderRadius: "6px",
        fontSize: "16px",
        cursor: "pointer",
        userSelect: "none",
        display: "flex",
        justifyContent: "space-between", // arrow on right
        alignItems: "center",
    };

    const subLayerRowStyle = {
        marginBottom: "6px", display: "flex",
        alignItems: "center", fontSize: "12px",
    };
    const lblName = {
        marginBottom: "6px",
        display: "flex",
        alignItems: "center",
        fontSize: "12px",
        userSelect: "none", cursor: "pointer",
        display: "flex", alignItems: "center", flexGrow: 1, fontSize: "12px",
    };


    //22 NOV LAyer reference 


    const buildFilter = (dist_cd, ulb_cd, wardno) => {
        const conditions = [];
        if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
        if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
        if (wardno) conditions.push(`wardno = '${wardno}'`);
        return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
    };

    useEffect(() => {

        if (!mapDiv.current) return;

        const map = new Map({ basemap: "topo-vector" });


        const mapView = new MapView({
            container: mapDiv.current,
            map,
            center: [77.4126, 23.2599],
            zoom: 6,
            ui: { components: ["attribution"] }
        });

        const adminSublayers = [
            { id: 1, title: "MP State", visible: false },
            { id: 3, title: "MP District", visible: true },
        ];

        const layer = new MapImageLayer({
            url: mainLayerUrl,
            sublayers: adminSublayers.map((s) => ({
                id: s.id,
                title: s.title,
                visible: s.visible,
            })),
        });

        map.add(layer);
        layerRef.current = layer;
        setView(mapView);

        //CODE DISTINCT


        //mapView.ui.add(measurementExpand, "top-left");

        //CODE DISTINCT


        mapView.ui.add(new Search({ view: mapView }), "top-left");
        mapView.ui.add(new Home({ view: mapView }), "top-left");
        mapView.ui.add(new Zoom({ view: mapView }), "top-left");
        mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
        mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");
        mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");

        mapView.when(() => {
            const printWidget = new Print({
                view: mapView,
                printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
            });

            const expandPrint = new Expand({
                view: mapView,
                content: printWidget
            });

            mapView.ui.add(expandPrint, "top-left");

            // ✅ Add and attach legend
            const legendWidget = new Legend({
                view: mapView,
                style: "classic"
            });

            const legendExpand = new Expand({
                view: mapView,
                content: legendWidget,
                expanded: false
            });

            mapView.ui.add(legendExpand, "top-left");
            legendWidgetRef.current = legendWidget;
        });

        //  legend  layerList

        const layerList = new LayerList({
            view: mapView
        });

        const expand = new Expand({
            view: mapView,
            content: layerList,
            expanded: false
        });
        //Layer LIST BLOCK
        // mapView.ui.add(expand, "top-left");

        // code  end  for legend  


        return () => {
            if (mapView) {
                mapView.destroy();
            }
        };
    }, []);

    useEffect(() => {
        if (view && layerRef.current && activeTabinfo) {
            setActiveTab(activeTabinfo);
            handleTabClick(activeTabinfo);
        }
    }, [view, activeTabinfo, selectedTitle]);

    useEffect(() => {
        if (layerRef.current) {
            const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
            layerRef.current.sublayers.forEach(sublayer => {
                sublayer.definitionExpression = filterExpr;
            });
        }
    }, [dist_cd, ulb_cd, wardno]);


    const fetchLegendALL = async (url, setLegendState) => {
        try {
            const response = await esriRequest(`${url}/legend`, {
                query: { f: "json" },
                responseType: "json"
            });

            const legends = {};
            response.data.layers.forEach((layer) => {
                const item = layer.legend?.[0];
                if (item && item.imageData) {
                    legends[layer.layerId] = {
                        label: item.label,
                        image: `data:${item.contentType};base64,${item.imageData}`
                    };
                }
            });

            setLegendState(legends);
        } catch (error) {
            console.error("Error fetching legend for:", url, error);
        }
    };

    // BHUPEN  STEP 3:  // METHOD calling  FOR setAAILegends
    //METHODSCALL FOR ADMIN
    useEffect(() => {
        fetchLegendALL(mainLayerUrl, setAdminLegends);
        fetchLegendALL(PROPERTY_URL, setPropertyLegends);
        //25MAY // BHUPEN  STEP 3
        fetchLegendALL(AAI_URL, setAAILegends);
        fetchLegendALL(Monuments_URL, setMonumentsLegends);
        fetchLegendALL(HousingBoard_URL, setHousingBoardLegends);
        fetchLegendALL(BDA_URL, setBDALegends);

        fetchLegendALL(New_identified_coloniesURL, setNew_identified_coloniesURLLegends);
        //25MAY // BHUPEN  STEP 3              
           fetchLegendALL(smartcity_abd_areaURL, setsmartcity_abd_areaURLLegends);
        //CODE 6AUG26
           fetchLegendALL(ImportantLandmarksURL, setImportantLandmarksURLLegends);

        fetchLegendALL(ASSETS_URL1, setASSETS_CentralLegends);
        fetchLegendALL(SBM_URL1, setSMBLegends);
        fetchLegendALL(AMRUT_URL, setAMRUTLegends);
        fetchLegendALL(WATER_URL, setWaterLegends);
        fetchLegendALL(WTRBWaterURL, setWTRBWaterURLLegends);
        //WaterBodies_URL , WaterBodiesSublayers

        fetchLegendALL(SEWER_URL, setSEWRAGELegends);
        fetchLegendALL(Transportation_URL, setTransportationLegends);
        fetchLegendALL(MPLanduse_URL, setMPLanduseLegends);
        fetchLegendALL(StormWaterURL, setStormWaterURLLegends);
        fetchLegendALL(LandSuitabilityURL, setLandSuitabilityURLLegends);
        //BHUPEN STEP 3 
        fetchLegendALL(GreenSpacesURL, setGreenSpacesURLLegends);
        fetchLegendALL(MASTER_PLAN_URL, setMasterPlanLegends);
        fetchLegendALL(SAMPDA_GUIDELINE_URL, setSampdaLegends);
        fetchLegendALL(BaseMapURL, setBasemapLegends);

    }, []);

    //  const  New_identified_coloniesURLLayerRef = useRef(null);
    //     const [ New_identified_coloniesURLLegends, setNew_identified_coloniesURLLegends] = useState({});   
    //     const [showNew_identified_coloniesURL, setshowNew_identified_coloniesURL] = useState(false);

    // activeTab

    useEffect(() => {
        const initial = {};
        let DataCheck;
        checkULBExists(ulbCode).then(exists => {
            if (exists) {
                // alert(ulbCode)

                DataCheck = 1;;

            } else {
                DataCheck = 0;

            }
        });
        // ADMIN LAYERS
        if (DataCheck === 1) {
            //  alert(DataCheck);

        }
        BaseMapURLURL_sublayer.forEach((s) => {
            initial[`BaseMap-${s.id}`] = s.id === 15 || s.id === 45 || s.id === 79;
        });

        adminSublayers.forEach((s) => {
            initial[`admin-${s.id}`] = s.id === 1 || s.id === 3;
        });
        /* ----------   PROPERTY TAB ---------- */

        PROPERTY_SUBLAYERS.forEach((s) => {
            initial[`property-${s.id}`] = s.id === 14 && activeTab === "property";
        });
        /* ----------WATER TAB  ---------- */
        waterSublayers.forEach((s) => {
            initial[`water-${s.id}`] = (s.id === 1 || s.id === 7) && activeTab === "water";
        });


        /* ----------SEWERAGE  TAB  ---------- */

        SEWER_SUBLAYERS.forEach((s) => {
            initial[`sewer-${s.id}`] = s.id === 5 && activeTab === "sewerage";
        });

        /* ----------Transportation TAB  ---------- */
        //  alert(activeTab);  45 ,56
        Transportation_SUBLAYERS.forEach((s) => {
            initial[`transport-${s.id}`] = (s.id === 45 || s.id === 56) && activeTab === "transportation";
        });



        // alert("selectedTitle");
        // alert(selectedTitle);

        if (selectedTitle === "All Assets") {
            ASSETS_Central_SUBLAYERS.forEach((s) => {
                initial[`govtassets-${s.id}`] = activeTab === "govtassets";
            });

        }

        else if (selectedTitle === "Center Govt") {
            ASSETS_Central_SUBLAYERS.forEach((s) => {
                initial[`govtassets-${2}`] = activeTab === "govtassets";
            });

        }
        else if (selectedTitle === "State Govt") {
            ASSETS_Central_SUBLAYERS.forEach((s) => {
                initial[`govtassets-${3}`] = activeTab === "govtassets";
            });
        }
        else if (selectedTitle === "Municipal Assets") {
            ASSETS_Central_SUBLAYERS.forEach((s) => {
                initial[`govtassets-${4}`] = activeTab === "govtassets";
            });
        }
        //  SBM 

        // if (selectedTitle === "sbm") {

        //     SBM_SUBLAYERS.forEach((s) => {
        //         initial[`s-${s.id}`] = activeTab === "sbm";

        //     });
        // }
        if (selectedTitle === "Processing Plant") {
            SBM_SUBLAYERS.forEach((s) => {
                initial[`sbm-${1}`] = activeTab === "sbm";
            });
        }
        else if (selectedTitle === "Dump Site") {
            SBM_SUBLAYERS.forEach((s) => {
                initial[`sbm-${2}`] = activeTab === "sbm";
            });
        }
        else if (selectedTitle === "Landfill") {
            SBM_SUBLAYERS.forEach((s) => {
                initial[`sbm-${3}`] = activeTab === "sbm";
            });
        }




        setCheckedLayers((prev) => ({
            ...prev,
            ...initial,
        }));
    }, [activeTab, selectedTitle, ulbCode]);


    // activeTab  6 JAN 2026  Code for Active operlayers step two  end 

    // CODE FOR ALL CHECKED
    //Admin ACTION
    const toggleAllAdmin = (isChecked) => {
        adminSublayers.forEach((s) => {

            handleToggleSublayer(
                secondLayerRef,
                "admin",
                s.id,
                isChecked
            );
        });
    };


    const AdminAllChecked = adminSublayers.every(
        (s) => checkedLayers[`admin-${s.id}`]
    );

    const AdminSomeChecked = adminSublayers.some(
        (s) => checkedLayers[`admin-${s.id}`]
    );
    const AdminIndeterminate = AdminSomeChecked && !AdminAllChecked;

    //PROPERTY ACTION

    const toggleAllProperty = (isChecked) => {
        PROPERTY_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                PropertierLayerRef,
                "property",
                s.id,
                isChecked
            );
        });
    };
    const PropertyAllChecked = PROPERTY_SUBLAYERS.every(
        (s) => checkedLayers[`property-${s.id}`]
    );

    const PropertySomeChecked = PROPERTY_SUBLAYERS.some(
        (s) => checkedLayers[`property-${s.id}`]
    );
    const PropertyIndeterminate = PropertySomeChecked && !PropertyAllChecked;


    // 25MAY AAI -  ACTION

    const toggleAllAAI = (isChecked) => {
        AAI_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                AAILayerRef,
                "AAI",
                s.id,
                isChecked
            );
        });
    };
    const AAIAllChecked = AAI_SUBLAYERS.every(
        (s) => checkedLayers[`AAI-${s.id}`]
    );

    const AAISomeChecked = AAI_SUBLAYERS.some(
        (s) => checkedLayers[`AAI-${s.id}`]
    );
    const AAIIndeterminate = AAISomeChecked && !AAIAllChecked;

    // AAI -  ACTION

    const toggleAllMonuments = (isChecked) => {
        Monuments_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                MonumentsLayerRef,
                "Monuments",
                s.id,
                isChecked
            );
        });
    };
    const MonumentsAllChecked = Monuments_SUBLAYERS.every(
        (s) => checkedLayers[`Monuments-${s.id}`]
    );

    const MonumentsSomeChecked = Monuments_SUBLAYERS.some(
        (s) => checkedLayers[`Monuments-${s.id}`]
    );
    const MonumentsIndeterminate = MonumentsSomeChecked && !MonumentsAllChecked;



    const toggleAllHousingBoard = (isChecked) => {
        HousingBoard_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                HousingBoardLayerRef,
                "HousingBoard",
                s.id,
                isChecked
            );
        });
    };
    const HousingBoardAllChecked = HousingBoard_SUBLAYERS.every(
        (s) => checkedLayers[`HousingBoard-${s.id}`]
    );

    const HousingBoardSomeChecked = HousingBoard_SUBLAYERS.some(
        (s) => checkedLayers[`HousingBoard-${s.id}`]
    );
    const HousingBoardIndeterminate = HousingBoardSomeChecked && !HousingBoardAllChecked;

    const toggleAllBDA = (isChecked) => {
        BDA_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                BDALayerRef,
                "BDA",
                s.id,
                isChecked
            );
        });
    };
    const BDAAllChecked = BDA_SUBLAYERS.every(
        (s) => checkedLayers[`BDA-${s.id}`]
    );

    const BDASomeChecked = BDA_SUBLAYERS.some(
        (s) => checkedLayers[`BDA-${s.id}`]
    );
    const BDAIndeterminate = BDASomeChecked && !BDAAllChecked;



    // MPLanduse Action  

    const toggleAllMPLanduse = (isChecked) => {
        MPLanduse_sublayer.forEach((s) => {
            handleToggleSublayer(
                MPLanduseLayerRef,
                "mplanduse",
                s.id,
                isChecked
            );
        });
    };



    const mplanduseAllChecked = MPLanduse_sublayer.every(
        (s) => checkedLayers[`mplanduse-${s.id}`]
    );

    const mplanduseSomeChecked = MPLanduse_sublayer.some(
        (s) => checkedLayers[`mplanduse-${s.id}`]
    );
    const mplanduseIndeterminate = mplanduseSomeChecked && !mplanduseAllChecked;


    // Landsuitability Action  

    const toggleAllLandSuitability = (isChecked) => {
        LandSuitabilityURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                LandSuitabilityURLLayerRef,
                "landsuitability",
                s.id,
                isChecked
            );
        });
    };
    const landsuitabilityAllChecked = LandSuitabilityURL_sublayer.every(
        (s) => checkedLayers[`landsuitability-${s.id}`]
    );

    const landsuitabilitySomeChecked = LandSuitabilityURL_sublayer.some(
        (s) => checkedLayers[`landsuitability-${s.id}`]
    );
    const landsuitabilityIndeterminate = landsuitabilitySomeChecked && !landsuitabilityAllChecked;


    //  ASSETS   Action   

    const toggleAllASSETS = (isChecked) => {
        ASSETS_Central_SUBLAYERS.forEach((s) => {

            handleToggleSublayer(
                ASSETS_CentralLayerRef,
                "govtassets",
                s.id,
                isChecked
            );
        });
    };

    const govtAllChecked = ASSETS_Central_SUBLAYERS.every(
        (s) => checkedLayers[`govtassets-${s.id}`]
    );

    const govtSomeChecked = ASSETS_Central_SUBLAYERS.some(
        (s) => checkedLayers[`govtassets-${s.id}`]
    );
    const govtIndeterminate = govtSomeChecked && !govtAllChecked;

    //SMB LAYERS

    const toggleAllsbm = (isChecked) => {
        SBM_SUBLAYERS.forEach((s) => {

            handleToggleSublayer(
                SMBLayerRef,
                "sbm",
                s.id,
                isChecked
            );
        });
    };

    const sbmAllChecked = SBM_SUBLAYERS.every(
        (s) => checkedLayers[`sbm-${s.id}`]
    );

    const sbmSomeChecked = SBM_SUBLAYERS.some(
        (s) => checkedLayers[`sbm-${s.id}`]
    );
    const sbmIndeterminate = sbmSomeChecked && !sbmAllChecked;


    // AMRUT LAYERS

    const toggleAllAMRUT = (isChecked) => {
        AMRUT_SUBLAYERS.forEach((s) => {

            handleToggleSublayer(
                AMRUTLayerRef,
                "AMRUT",
                s.id,
                isChecked
            );
        });
    };

    const AMRUTAllChecked = AMRUT_SUBLAYERS.every(
        (s) => checkedLayers[`AMRUT-${s.id}`]
    );

    const AMRUTSomeChecked = AMRUT_SUBLAYERS.some(
        (s) => checkedLayers[`AMRUT-${s.id}`]
    );
    const AMRUTIndeterminate = AMRUTSomeChecked && !AMRUTAllChecked;



    // WATER ACTION
    const toggleAllWater = (isChecked) => {
        waterSublayers.forEach((s) => {
            handleToggleSublayer(
                WaterLayerRef,
                "water",
                s.id,
                isChecked
            );
        });
    };


    const waterAllChecked = waterSublayers.every(
        (s) => checkedLayers[`water-${s.id}`]
    );

    const waterSomeChecked = waterSublayers.some(
        (s) => checkedLayers[`water-${s.id}`]
    );
    const waterIndeterminate = waterSomeChecked && !waterAllChecked;



    // WTRB ACTION
    const toggleAllWTRB = (isChecked) => {
        WTRBWaterURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                WTRBWaterURLLayerRef,
                "WTRB",
                s.id,
                isChecked
            );
        });
    };
    const WTRBAllChecked = WTRBWaterURL_sublayer.every(
        (s) => checkedLayers[`WTRB-${s.id}`]
    );

    const WTRBSomeChecked = WTRBWaterURL_sublayer.some(
        (s) => checkedLayers[`WTRB-${s.id}`]
    );
    const WTRBIndeterminate = WTRBSomeChecked && !WTRBAllChecked;



    // Storm ACTION
    const toggleAllStorm = (isChecked) => {
        StormWaterURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                StormWaterURLLayerRef,
                "storm",
                s.id,
                isChecked
            );
        });
    };
    const stormAllChecked = StormWaterURL_sublayer.every(
        (s) => checkedLayers[`storm-${s.id}`]
    );

    const stormSomeChecked = StormWaterURL_sublayer.some(
        (s) => checkedLayers[`storm-${s.id}`]
    );
    const stormIndeterminate = stormSomeChecked && !stormAllChecked;


    // Sewer ACTION
    const toggleAllSewer = (isVisible) => {
        SEWER_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                SEWRAGELayerRef, // MapImageLayer ref
                "sewer",       // group key
                s.id,
                isVisible
            );
        });
    };
    const sewerAllChecked = SEWER_SUBLAYERS.every(
        (s) => checkedLayers[`sewer-${s.id}`]
    );

    const sewerSomeChecked = SEWER_SUBLAYERS.some(
        (s) => checkedLayers[`sewer-${s.id}`]
    );
    const sewerIndeterminate = sewerSomeChecked && !sewerAllChecked;

    // Transportation_SUBLAYERS

    const toggleAllTransportation = (isVisible) => {
        Transportation_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                TransportationLayerRef, // MapImageLayer ref
                "transport",       // group key
                s.id,
                isVisible
            );
        });
    };


    const transportAllChecked = Transportation_SUBLAYERS.every(
        (s) => checkedLayers[`transport-${s.id}`]
    );

    const transportSomeChecked = Transportation_SUBLAYERS.some(
        (s) => checkedLayers[`transport-${s.id}`]
    );
    const transportIndeterminate = transportSomeChecked && !transportAllChecked;




    const toggleAllMasterplan = (isVisible) => {
        MASTER_PLAN_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                masterPlanLayerRef, // MapImageLayer ref
                "masterplan",       // group key
                s.id,
                isVisible
            );
        });
    };

    const masterplanAllChecked = MASTER_PLAN_SUBLAYERS.every(
        (s) => checkedLayers[`masterplan-${s.id}`]);

    const masterplanSomeChecked = MASTER_PLAN_SUBLAYERS.some(
        (s) => checkedLayers[`masterplan-${s.id}`]
    );
    const masterplanIndeterminate = masterplanSomeChecked && !masterplanAllChecked;

    //BHUPEN STEP 4 
    const toggleAllGreenSpaces = (isChecked) => {
        GreenSpacesURL_sublayer.forEach((s) => {

            handleToggleSublayer(
                GreenSpacesURLLayerRef,
                "GreenSpaces",
                s.id,
                isChecked
            );
        });
    };

    const GreenSpacesAllChecked = GreenSpacesURL_sublayer.every(
        (s) => checkedLayers[`GreenSpaces-${s.id}`]
    );

    const GreenSpacesSomeChecked = GreenSpacesURL_sublayer.some(
        (s) => checkedLayers[`GreenSpaces-${s.id}`]
    );
    const GreenSpacesIndeterminate = GreenSpacesSomeChecked && !GreenSpacesAllChecked;


    //  SAMPDA_GUIDELINE_SUBLAYERS  sampdaGuidelineLayerRef,

    const toggleAllSampda = (isVisible) => {
        SAMPDA_GUIDELINE_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                sampdaGuidelineLayerRef, // MapImageLayer ref
                "sampda",       // group key
                s.id,
                isVisible
            );
        });
    };

    const sampdaAllChecked = SAMPDA_GUIDELINE_SUBLAYERS.every(
        (s) => checkedLayers[`sampda-${s.id}`]);

    const sampdaSomeChecked = SAMPDA_GUIDELINE_SUBLAYERS.some(
        (s) => checkedLayers[`sampda-${s.id}`]
    );
    const sampdaIndeterminate = sampdaSomeChecked && !sampdaAllChecked;

    //  BaseMapURLURL_sublayer   , BasemapLayerRef  CODE FOR BASEMAP

    const toggleAllBaseMap = (isVisible) => {
        BaseMapURLURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                BasemapLayerRef, // MapImageLayer ref
                "BaseMap",       // group key
                s.id,
                isVisible
            );
        });
    };
    const BaseMapAllChecked = BaseMapURLURL_sublayer.every(
        (s) => checkedLayers[`BaseMap-${s.id}`]);

    const BaseMapSomeChecked = BaseMapURLURL_sublayer.some(
        (s) => checkedLayers[`BaseMap-${s.id}`]
    );
    const BaseMapIndeterminate = BaseMapAllChecked && !BaseMapSomeChecked;

    // CODE FOR BASEMAP

    //  const  New_identified_coloniesURLLayerRef = useRef(null);
    // const [ New_identified_coloniesURLLegends, setNew_identified_coloniesURLLegends] = useState({});   
    // const [showNew_identified_coloniesURL, setshowNew_identified_coloniesURL] = useState(false);

    // CODE FOR NEW COLONY
    const toggleAllNew_identified_coloniesURL = (isVisible) => {
        New_identified_coloniesURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                New_identified_coloniesURLLayerRef, // MapImageLayer ref
                "New_identified_colonies",       // group key
                s.id,
                isVisible
            );
        });
    };
    const New_identified_coloniesURLAllChecked = New_identified_coloniesURL_sublayer.every(
        (s) => checkedLayers[`New_identified_colonies-${s.id}`]);

    const New_identified_coloniesURLSomeChecked = New_identified_coloniesURL_sublayer.some(
        (s) => checkedLayers[`New_identified_colonies-${s.id}`]
    );
    const New_identified_coloniesURLIndeterminate = New_identified_coloniesURLAllChecked && !New_identified_coloniesURLSomeChecked;

    // CODE FOR NEW COLONY



    // CODE FOR smartcity_abd_area

    const toggleAllsmartcity_abd_areaURL = (isVisible) => {
        smartcity_abd_areaURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                smartcity_abd_areaURLLayerRef, // MapImageLayer ref
                "smartcity_abd_area",       // group key
                s.id,
                isVisible
            );
        });
    };
    const smartcity_abd_areaURLAllChecked = smartcity_abd_areaURL_sublayer.every(
        (s) => checkedLayers[`smartcity_abd_area-${s.id}`]);

    const smartcity_abd_areaURLSomeChecked = smartcity_abd_areaURL_sublayer.some(
        (s) => checkedLayers[`smartcity_abd_area-${s.id}`]
    );
    const smartcity_abd_areaURLIndeterminate = smartcity_abd_areaURLAllChecked && !smartcity_abd_areaURLSomeChecked;

    // CODE FOR ImportantLandmarks



 const toggleAllImportantLandmarksURL = (isVisible) => {
       ImportantLandmarksURL_sublayer.forEach((s) => {
            handleToggleSublayer(
                ImportantLandmarksURLLayerRef, // MapImageLayer ref
                "ImportantLandmarks",       // group key
                s.id,
                isVisible
            );
        });
    };
    const ImportantLandmarksURLAllChecked = ImportantLandmarksURL_sublayer.every(
        (s) => checkedLayers[`ImportantLandmarks-${s.id}`]);

    const ImportantLandmarksURLSomeChecked = ImportantLandmarksURL_sublayer.some(
        (s) => checkedLayers[`ImportantLandmarks-${s.id}`]
    );
    const ImportantLandmarksURLIndeterminate = ImportantLandmarksURLAllChecked && !ImportantLandmarksURLSomeChecked;






    const handleToggleSublayer = (
        layerRef,
        groupKey,     // "admin" | "property" | "water" | "storm" | etc
        sublayerId,
        isVisible
    ) => {
        // 1️⃣ Toggle ArcGIS sublayer

        const sublayer = layerRef.current?.allSublayers?.find(
            (s) => s.id === sublayerId
        );
        // CODE FOR BASE MAP

        if (sublayer) {
            sublayer.visible = isVisible;

        }
        else {

        }

        // 2️⃣ Save checkbox state (React)
        const stateKey = `${groupKey}-${sublayerId}`;

        setCheckedLayers((prev) => ({
            ...prev,
            [stateKey]: isVisible
        }));

    };


    useEffect(() => {
        if (showAmrut) {
            loadSublayerCounts();
        }
    }, [showAmrut]);

    const [featureCounts, setFeatureCounts] = useState({});

    const loadSublayerCounts = async () => {
        const counts = {};

        for (const s of AMRUT_SUBLAYERS) {
            const sublayer = AMRUTLayerRef.current?.findSublayerById(s.id);
            if (!sublayer) continue;

            try {
                const fl = await sublayer.createFeatureLayer();
                const count = await fl.queryFeatureCount();
                counts[s.id] = count;
            } catch (err) {
                counts[s.id] = 0;
            }
        }

        setFeatureCounts(counts);
    };



    async function checkULBExists(ulb_cd) {
        const url =
            "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/FeatureServer/5/query";

        const params = new URLSearchParams({
            where: "1=1",
            outFields: "ulb_cd,name",
            returnGeometry: "false",
            f: "json"
        });

        try {
            const response = await fetch(`${url}?${params.toString()}`);
            const data = await response.json();

            if (!data.features) return false;

            // Extract only ulb_cd list
            const ulbList = data.features.map(f => f.attributes.ulb_cd);

            // Check if provided ulb_cd exists
            return ulbList.includes(ulb_cd);
        } catch (error) {
            console.error("Error checking ULB:", error);
            return false;
        }
    }

    // code end legends

    useEffect(() => {
        if (!view) return;
        view.graphics.removeAll();
        handleTabClick(activeTabinfo);

        if (selectedWard && wardCode && ulbCode) {
            zoomToWard(wardCode, ulbCode);
        } else if (selectedUlb && ulbCode) {
            zoomToUlb(ulbCode);
        } else if (selectedDistrict && districtCode) {
            zoomToDistrict(selectedDistrict);
        }
    }, [selectedDistrict, selectedUlb, selectedWard, districtCode, ulbCode, wardCode, view]);

    const zoomToDistrict = async (districtName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
        const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 255, 0], width: 2.0 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to district:", error);
        }
    };

    const zoomToUlb = async (ulbCode) => {
        // alert(ulbName);
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/94')}` });
        const query = new Query({ where: `ulb_cd  = '${ulbCode}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to ULB:", error);
        }
    };

    const zoomToWard = async (wardCode, ulbCode) => {
        //  alert(wardCode)
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/95')}` });
        const query = new Query({ where: `wardno = '${wardCode}' AND ulb_cd = '${ulbCode}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {

                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 255, 0], width: 1.5 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to ward:", error);
        }
    };

    const LoadZoom = () => {
        //  alert(`Card Title on MAP: ${selectedTitle}`);
        if (activeTabRef === "1") {
            activeTabRef = "0"
            // zoomToDistrictOUT(selectedDistrict);
            view.graphics.removeAll(); // Clear any highlights

            // Go to the initial extent or center
            view.goTo({
                center: [77.4126, 23.2599],
                zoom: 6,
                // ui: { components: ["attribution"] }
            });

        }
        else {
            if (selectedWard && wardCode && ulbCode) {
                zoomToWard(selectedWard, ulbCode);
            } else if (selectedUlb && ulbCode) {
                zoomToUlb(selectedUlb);
            } else if (selectedDistrict && districtCode) {
                zoomToDistrict(selectedDistrict);
            }
        }

    };



    const calculatedHeight = useMemo(() => {

        if (isRightSide) {
            return "calc(100vh - 110px)"
        }

        return "calc(100vh - 388px)";
    }, [isRightSide]);
    // code for load others Layer 23MAY
    const [openPopup, setOpenPopup] = useState(false);
    const [openInfoPopup, setOpenInfoPopup] = useState(false);
    const [openLayerPopup, setOpenLayerPopup] = useState(false);


    // RESET  LAYERS
    const handleReset = () => {
        if (!view) return;
        view.removeAll();
        // Remove map layers
        view.map.layers.removeAll();
        view.graphics.removeAll();

        handleTabClick();

        // ✅ Uncheck all checkboxes
        setCheckedLayers({});
    };
    // END RESET LAYERS

    // View  LAYERS Fetures
    const [tableData, setTableData] = useState([]);
    const [tableDataLayerRef, setTableDataLayerRef] = useState([]);
    const [showPopup, setShowPopup] = useState(false);

    const handleViewLayer = async (LayerRef, s) => {

        if (s.id) {

            //  alert(s.title);
        }
        else {
            // alert(s.title);
        }


        try {
            const layer = LayerRef.current;
            const sublayer = layer.findSublayerById(s.id);

            // const query = sublayer.createQuery();
            // query.where = "1=1";
            // query.outFields = ["*"];
            // query.returnGeometry = false;
            const query = sublayer.createQuery();

            query.where = buildFilter(dist_cd, ulb_cd, wardno);

            query.outFields = ["*"];
            query.returnGeometry = false;

            const result = await sublayer.queryFeatures(query);

            setTableData(result.features);
            setTableDataLayerRef(s.title);
            setShowPopup(true);   // ✅ OPEN POPUP

        } catch (err) {
            console.error(err);
        }
    };

    const [directorFilter, setDirectorFilter] = useState("");
    const [searchText, setSearchText] = useState("");

    const filteredData = tableData.filter((item) => {
        const values = Object.values(item.attributes || {}).join(" ").toLowerCase();

        const matchesSearch = values.includes(searchText.toLowerCase());

        const matchesDirector =
            !directorFilter ||
            item.attributes?.asi_regional_director === directorFilter;

        return matchesSearch && matchesDirector;
    });



    // CODE FOR DOWNLOAD
    const downloadExcel = () => {
        if (!filteredData.length) return;

        const data = filteredData.map((item, index) => {
            const obj = {};

            // ✅ Add S.No first
            obj["S.NO"] = index + 1;

            // ✅ Add remaining columns
            Object.keys(item.attributes || {}).forEach((key) => {
                obj[key.toUpperCase()] = item.attributes[key];
            });

            return obj;
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // ✅ Auto column width (including S.No)
        const colWidths = Object.keys(data[0]).map((key) => ({
            wch: key.length + 5
        }));
        worksheet["!cols"] = colWidths;

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // File name with date
        const fileName = `table_data_${new Date().toISOString().slice(0, 10)}.xlsx`;

        // Download
        XLSX.writeFile(workbook, fileName);
    };


    let blinkInterval;
    const blinkRef = useRef(null);
const handleZoom = (item) => {
    // ✅ Stop previous animation
    if (blinkRef.current) {
        clearInterval(blinkRef.current);
        blinkRef.current = null;
    }

    const lat = item.attributes?.latitude;
    const lon = item.attributes?.longitude;
    const Name = item.attributes?.Name;

    if (!lat || !lon) return;

    setShowPopup(false);

    const point = {
        type: "point",
        longitude: lon,
        latitude: lat
    };

    // ✅ Zoom to location
    view.goTo({
        center: [lon, lat],
        zoom: 15
    });

    // ✅ Clear old graphics ONCE
    view.graphics.removeAll();

    let size = 10;
    let growing = true;

    const pointGraphic = {
        geometry: point,
        attributes: item.attributes,
        symbol: {
            type: "simple-marker",
            style: "circle",
            color: "#3b82f6",
            size: size,
            outline: {
                color: "#1e3a8a",
                width: 2
            }
        },

        popupTemplate: {
            title: Name || "Location Details",
            content: (feature) => {
                const attrs = feature.graphic.attributes;

                return `
                <div style="max-height:250px;overflow:auto;padding:8px;background:#f9fafb;border-radius:6px;">
                    <table style="width:100%;font-size:12px;border-collapse:collapse;">
                        ${Object.keys(attrs || {}).map(key => `
                            <tr>
                                <td style="font-weight:600;padding:6px;border-bottom:1px solid #e5e7eb;">
                                    ${key.toUpperCase()}
                                </td>
                                <td style="padding:6px;border-bottom:1px solid #e5e7eb;">
                                    ${attrs[key] ?? "-"}
                                </td>
                            </tr>
                        `).join("")}
                    </table>
                </div>
                `;
            }
        }
    };

    view.graphics.add(pointGraphic);

    // ✅ Open popup
    view.popup.open({
        features: [pointGraphic],
        location: point
    });

    // ✅ Smooth Pulse Animation (NO removeAll)
    blinkRef.current = setInterval(() => {
        size = growing ? size + 2 : size - 2;

        if (size >= 22) growing = false;
        if (size <= 10) growing = true;

        // 🔥 ONLY update symbol (no redraw flicker)
        pointGraphic.symbol = {
            ...pointGraphic.symbol,
            size: size
        };

    }, 200);
};
    // const [directorFilter, setDirectorFilter] = useState("");


    // get unique values for dropdown
    const directorList = [
        ...new Set(
            tableData.map((item) => item.attributes?.asi_regional_director)
        ),
    ].filter(Boolean);


    // End View  LAYERS Fetures





    const handleTabClick = (key) => {

        console.log("handleTabClick key", key);
        setActiveTab(key);
        const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

        // alert(key);

        if (view && layerRef.current) {
            view.graphics.removeAll();
            LoadZoom();

            view.map.removeAll();

            if ((key === "total2" || key === "property2" || key === "Enp" || key === "gis" || key === "abpas") && view) {
                const newLayer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [
                        { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                        { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                        { id: 5, title: "ULB", visible: false, definitionExpression: filterExpr },
                        { id: 7, title: "Ward", visible: false, definitionExpression: filterExpr },
                        {
                            id: 14, title: "Property", visible: key === 'property', definitionExpression: filterExpr,

                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property Info",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ulbname ", label: "ULB Name" },
                                            { fieldName: "area", label: "Area" },
                                        ]
                                    }
                                ]
                            }//poptype close

                        },
                        { id: 15, title: "Structure", visible: key === 'property', definitionExpression: filterExpr }
                    ]
                });

                view.map.add(newLayer);
                layerRef.current = newLayer;

                // ✅ Update legend dynamically
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: newLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }

            if (key === "property2" && view) {
                const newLayer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [
                        { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                        { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                        { id: 5, title: "ULB", visible: false, definitionExpression: filterExpr },
                        { id: 7, title: "Ward", visible: false, definitionExpression: filterExpr },
                        {
                            id: 14, title: "Property", visible: key === 'property', definitionExpression: filterExpr,

                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property Info",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ulbname ", label: "ULB Name" },
                                            { fieldName: "area", label: "Area" },
                                        ]
                                    }
                                ]
                            }//poptype close

                        },
                        { id: 15, title: "Structure", visible: key === 'property', definitionExpression: filterExpr }
                    ]
                });

                view.map.add(newLayer);
                layerRef.current = newLayer;

                // ✅ Update legend dynamically
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: newLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }


            if (key === "sewerage2" && view) {

                //admin layer 
                const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";
                const layerGroups = {
                    // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                    admin: [1, 3]
                };

                const adminLayer = new MapImageLayer({
                    url: LayerUrl1,
                    sublayers: layerGroups.admin.map(id => ({
                        id,
                        title: `Admin Layer ${id}`,
                        visible: true
                    }))
                });

                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                const sewerageLayer = new MapImageLayer({
                    url: "https://mpurbangis.in/server/rest/services/temp_n/sewerage_project/MapServer",
                    sublayers: [
                        {
                            id: 1, title: "stp", visible: true, definitionExpression: filterExpr,

                        },
                        { id: 2, title: "mps", visible: true, definitionExpression: filterExpr },
                        { id: 3, title: "ips", visible: true, definitionExpression: filterExpr },
                        { id: 4, title: "manhole", visible: true, definitionExpression: filterExpr },
                        {
                            id: 5, title: "sewer_network", visible: true, definitionExpression: filterExpr,
                        }
                    ]
                });

                const layer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [adminLayer],
                });

                view.map.add(layer);
                layerRef.current = layer;
                // setView(mapView);

                view.map.add(sewerageLayer);
                // legendWidgetRef sewerageLayer;
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: sewerageLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }

            } // if  end

            if (key === "population" && view) {
                //admin layer 
                const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";
                const layerGroups = {
                    // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                    admin: [1, 3]
                };
                const adminLayer = new MapImageLayer({
                    url: LayerUrl1,
                    sublayers: layerGroups.admin.map(id => ({
                        id,
                        title: `Admin Layer ${id}`,
                        visible: true
                    }))
                });

                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                const populationLayer = new MapImageLayer({
                    url: "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer",
                    sublayers: [
                        { id: 95, title: "MP Ward", visible: true, definitionExpression: filterExpr },
                        { id: 7, title: "Municipalward_boundary  ", visible: true, definitionExpression: filterExpr },
                        { id: 5, title: "Municipal_area ", visible: true, definitionExpression: filterExpr, minScale: 5000, maxScale: 500 },

                        { id: 94, title: "MP ULB", visible: true, definitionExpression: filterExpr },

                        { id: 3, title: "MP District", visible: true, definitionExpression: filterExpr },

                        { id: 1, title: "MP State", visible: true, definitionExpression: filterExpr },


                    ]
                });

                const layer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [adminLayer],
                });
                view.map.add(layer);
                layerRef.current = layer;            // setView(mapView);
                view.map.add(populationLayer);
                // populationLayerRef.current = populationLayer;
                // legendWidgetRef populationLayer;
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: populationLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }

            }// if end 

            if (key === "transportation2" && view) {

                const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";
                const layerGroups = {
                    admin: [1, 3]
                };
                const adminLayer = new MapImageLayer({
                    url: LayerUrl1,
                    sublayers: layerGroups.admin.map(id => ({
                        id,
                        title: `Admin Layer ${id}`,
                        visible: true
                    }))
                });

                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                // code for 
                // //transportation: [1, 3, 5, 7, 45, 46, 56, 57, 58],

                const transportationLayer = new MapImageLayer({
                    url: "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer",
                    sublayers: [
                        { id: 1, title: "mpstate", visible: false, definitionExpression: filterExpr },
                        { id: 3, title: "mpdistrict", visible: false, definitionExpression: filterExpr },
                        { id: 5, title: "municipal_area ", visible: false, definitionExpression: filterExpr, minScale: 5000, maxScale: 500 },
                        { id: 7, title: "municipalward_boundary  ", visible: false, definitionExpression: filterExpr },
                        {
                            id: 45, title: "roadcenterline", visible: true, definitionExpression: filterExpr


                            , renderer: {
                                type: "simple",
                                symbol: {
                                    type: "simple-line",
                                    color: [128, 128, 128], // Grey color
                                    width: 1
                                }
                            }
                        },

                        {
                            id: 46, title: "road_poly ", visible: false, definitionExpression: filterExpr,


                            renderer: {
                                type: "simple",
                                symbol: {
                                    type: "simple-line",
                                    color: [128, 128, 128], // Grey color
                                    width: 1
                                }
                            }

                        },
                        { id: 56, title: "railwaycenterline ", visible: false, definitionExpression: filterExpr },
                        { id: 57, title: "railwaypoly ", visible: false, definitionExpression: filterExpr },
                        { id: 58, title: "railwayproperty  ", visible: false, definitionExpression: filterExpr }

                    ]
                });

                const layer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [adminLayer],
                });
                view.map.add(layer);
                layerRef.current = layer;            // setView(mapView);
                view.map.add(transportationLayer);
                // PropertiesLayerRef.current = propertyLayer;

                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: transportationLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }// if end
            //taxation
            if (key === "taxation" && view) {
                // code for Proerties
                const newLayer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [
                        { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                        { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                        { id: 5, title: "ULB", visible: false, definitionExpression: filterExpr },
                        { id: 7, title: "Ward", visible: false, definitionExpression: filterExpr },
                        {
                            id: 14, title: "Property", visible: key === 'property', definitionExpression: filterExpr,

                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property Info",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ulbname ", label: "ULB Name" },
                                            { fieldName: "area", label: "Area" },
                                        ]
                                    }
                                ]
                            }//poptype close

                        },
                        { id: 15, title: "Structure", visible: key === 'property', definitionExpression: filterExpr }
                    ]
                });

                view.map.add(newLayer);
                layerRef.current = newLayer;

                // ✅ Update legend dynamically
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: newLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }



            }
            // code for Ecosenstive
            if (key === "ecosenstivearea" && view) {

                //admin layer 
                const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";

                const layerGroups = {
                    // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                    admin: [1, 3]
                };

                const adminLayer = new MapImageLayer({
                    url: LayerUrl1,
                    sublayers: layerGroups.admin.map(id => ({
                        id,
                        title: `Admin Layer ${id}`,
                        visible: true
                    }))
                });

                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

                const layer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [adminLayer],
                });

                view.map.add(layer);
                layerRef.current = layer;
                // setView(mapView);




                // ✅ Update legend dynamically
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{

                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }// if end 

            if (key === "govtassets2" && view) {

                if (selectedTitle === "All Assets" || selectedTitle === "Available ULB/Total ULB") {

                    view.graphics.removeAll();
                    //admin layer 
                    const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";

                    const layerGroups = {
                        // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                        admin: [1, 3]
                    };

                    const adminLayer = new MapImageLayer({
                        url: LayerUrl1,
                        sublayers: layerGroups.admin.map(id => ({
                            id,
                            title: `Admin Layer ${id}`,
                            visible: true
                        }))
                    });
                    //Central Govt Assets ,  State Govt Assets,Municipal Assets
                    //  alert("key Value = ",+key);

                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                    const waterLayer = new MapImageLayer({
                        url: ASSETS_URL1,
                        sublayers: [
                            {
                                id: 1, title: "All Assets", visible: true,
                                definitionExpression: filterExpr,
                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [

                                                { fieldName: "districtname", label: "District Name" },
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "wardname", label: "Ward Name" },
                                                { fieldName: "type", label: "Assets Type" },
                                                { fieldName: "description", label: "Description" },
                                                { fieldName: "name", label: "Name" },
                                                { fieldName: "remarks", label: "Remarks" }
                                            ]
                                        },

                                    ]
                                }
                            },]


                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(waterLayer);

                    view.map.add(waterLayer);
                    layerRef.current = waterLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: waterLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }
                }
                if (selectedTitle === "Center Govt") {
                    view.graphics.removeAll();
                    //admin layer 
                    const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";

                    const layerGroups = {
                        // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                        admin: [1, 3]
                    };

                    const adminLayer = new MapImageLayer({
                        url: LayerUrl1,
                        sublayers: layerGroups.admin.map(id => ({
                            id,
                            title: `Admin Layer ${id}`,
                            visible: true
                        }))
                    });
                    //Central Govt Assets ,  State Govt Assets,Municipal Assets
                    //  alert("key Value = ",+key);

                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                    const waterLayer = new MapImageLayer({
                        url: ASSETS_URL1,
                        sublayers: [
                            { id: 1, title: "All Assets", visible: false, definitionExpression: filterExpr },

                            {
                                id: 2, title: "Central Govt Assets", visible: true,
                                definitionExpression: filterExpr,

                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content:
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "districtname", label: "District Name" },
                                            { fieldName: "ulbname", label: "ULB Name" },
                                            { fieldName: "wardno", label: "Ward No" },
                                            { fieldName: "wardname", label: "Ward Name" },
                                            { fieldName: "type", label: "Assets Type" },
                                            { fieldName: "description", label: "Description" },
                                            { fieldName: "name", label: "Name" },
                                            { fieldName: "remarks", label: "Remarks" }
                                        ]
                                    },


                                }
                            },]


                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(waterLayer);

                    view.map.add(waterLayer);
                    layerRef.current = waterLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: waterLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }
                }

                if (selectedTitle === "State Govt") {
                    view.graphics.removeAll();
                    //admin layer 
                    const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";

                    const layerGroups = {
                        // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                        admin: [1, 3]
                    };

                    const adminLayer = new MapImageLayer({
                        url: LayerUrl1,
                        sublayers: layerGroups.admin.map(id => ({
                            id,
                            title: `Admin Layer ${id}`,
                            visible: true
                        }))
                    });
                    //Central Govt Assets ,  State Govt Assets,Municipal Assets
                    //  alert("key Value = ",+key);

                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                    const waterLayer = new MapImageLayer({
                        url: ASSETS_URL1,
                        sublayers: [
                            { id: 1, title: "All Assets", visible: false, definitionExpression: filterExpr },

                            {
                                id: 3, title: "State Govt Assets", visible: true,
                                definitionExpression: filterExpr,

                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [
                                                { fieldName: "districtname", label: "District Name" },
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "wardname", label: "Ward Name" },
                                                { fieldName: "type", label: "Assets Type" },
                                                { fieldName: "description", label: "Description" },
                                                { fieldName: "name", label: "Name" },
                                                { fieldName: "remarks", label: "Remarks" }
                                            ]
                                        },

                                    ]
                                }
                            },]

                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(waterLayer);

                    view.map.add(waterLayer);
                    layerRef.current = waterLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: waterLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }
                }
                //Municipal Assets
                if (selectedTitle === "Municipal Assets") {
                    view.graphics.removeAll();
                    //admin layer 
                    const LayerUrl1 = "https://mpurbangis.in/server/rest/services/temp_n/urbangis_temp/MapServer";

                    const layerGroups = {
                        // admin: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
                        admin: [1, 3]
                    };

                    const adminLayer = new MapImageLayer({
                        url: LayerUrl1,
                        sublayers: layerGroups.admin.map(id => ({
                            id,
                            title: `Admin Layer ${id}`,
                            visible: true
                        }))
                    });
                    //Central Govt Assets ,  State Govt Assets,Municipal Assets
                    //  alert("key Value = ",+key);

                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                    const waterLayer = new MapImageLayer({
                        url: ASSETS_URL1,
                        sublayers: [
                            {
                                id: 1, title: "All Assets", visible: false,
                                definitionExpression: filterExpr,
                            },

                            {
                                id: 4, title: "Municipal Assets Assets", visible: true,
                                definitionExpression: filterExpr,
                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [
                                                { fieldName: "districtname", label: "District Name" },
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "wardname", label: "Ward Name" },
                                                { fieldName: "type", label: "Assets Type" },
                                                { fieldName: "description", label: "Description" },
                                                { fieldName: "name", label: "Name" },
                                                { fieldName: "remarks", label: "Remarks" }
                                            ]
                                        },

                                    ]
                                }
                            },]

                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(waterLayer);

                    view.map.add(waterLayer);
                    layerRef.current = waterLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: waterLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }


                }// if end 


            }// if end 


            if (key === "abpas" && view) {


                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                const adminLayer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [
                        { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                        { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                        { id: 5, title: "ULB", visible: true, definitionExpression: filterExpr },

                    ]
                });

                view.map.add(adminLayer);
                layerRef.current = adminLayer;

                //   alert(`filterExpr: ${filterExpr}`);
                const ABPassLayer = new MapImageLayer({
                    url: "https://mpurbangis.in/server/rest/services/temp_n/abpas_property_mview/MapServer",
                    sublayers: [
                        {
                            id: 1, visible: true, definitionExpression: filterExpr,

                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property Relation ID: {relation_id}",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "ulbname", label: "ULB Name" },
                                            { fieldName: "wardno", label: "Ward No" },
                                            { fieldName: "relation_id", label: "Relation Id" },
                                            { fieldName: "gis_uniqueid", label: "GIS Unique ID" },
                                            { fieldName: "ownername", label: "Owner Name" },
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "diff_builtup_area_sqft", label: "Difference Builtup Area (Sqft)" },
                                            { fieldName: "diff_plot_area_sqft", label: "Difference Plot Area (Sqft)" },
                                            { fieldName: "gis_no_of_floors", label: "Actual Floor (Ground)" },
                                            { fieldName: "abpas_no_of_floors", label: "Approved Floor (ABPAS)" }, // FIXED
                                            { fieldName: "floor_status", label: "Floor Status" },
                                            { fieldName: "land_use_status", label: "Landuse Status" },
                                        ]
                                    },
                                    {
                                        type: "media",
                                        mediaInfos: [
                                            {
                                                title: "<b>Property Photo</b>",
                                                type: "image",
                                                caption: "Linked to {relation_id}",
                                                value: {
                                                    sourceURL:
                                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type: "text",
                                        text: `
        <img src="" style="width:200px; height: 20px; border:1px solid #ccc;" />
      `
                                    }
                                ]
                            }



                        },
                    ]
                });
                view.when(() => {
                    const style = document.createElement("style");
                    style.innerHTML = `
    /* Outer popup container - controls total popup height */
    .esri-popup__main-container {
      max-height: 900px !important;   /* total popup height */
      width: 360px !important;        /* optional: limit popup width */
      box-sizing: border-box !important;
    }

    /* Header / title should not scroll - content area will */
    .esri-popup__header, 
    .esri-popup__footer {
      flex: 0 0 auto !important;
    }

    /* Inner content area that should scroll */
    .esri-popup__content {
      max-height: calc(720px - 72px) !important; /* subtract header/footer approx */
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important; /* smooth on touch devices */
    }

    /* If ArcGIS uses nested content wrappers, ensure they scroll too */
    .esri-popup__content .esri-feature-fields,
    .esri-popup__content .esri-popup__media,
    .esri-popup__content .esri-popup__text,
    .esri-popup__content .esri-popup__content-container {
      max-height: inherit !important;
      overflow: visible !important;
    }

    /* Constrain images so they don't blow out the layout */
    .esri-popup__content img,
    .esri-popup__media img {
      max-width: 100% !important;
      height: auto !important;
      max-height: 640px !important; /* adjust to taste */
      display: block !important;
      margin: 6px 0 !important;
      border-radius: 6px !important;
      object-fit: cover !important;
    }

    /* Optional: nicer scrollbar on desktop */
    .esri-popup__content::-webkit-scrollbar { width: 10px; }
    .esri-popup__content::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: rgba(0,0,0,0.15);
    }
  `;
                    document.head.appendChild(style);
                });




                const layer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [adminLayer],
                });

                view.map.add(layer);
                layerRef.current = layer;
                // setView(mapView);
                view.map.add(ABPassLayer);


                layerRef.current = ABPassLayer;

                // ✅ Update legend dynamically
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: ABPassLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }

                //  loadLayers();
            }// if end 



            if (key === "abpas2" && view) {
                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                const adminLayer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [
                        { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                        { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                        { id: 5, title: "ULB", visible: true, definitionExpression: filterExpr },
                    ]
                });
                view.map.add(adminLayer);
                layerRef.current = adminLayer;
                if (key === "diff_builtup_area_sqft>50" && view) {

                    //   alert(`total on MAP: ${key}`);

                    let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                    // Add condition for remarks = 'Surveyed'
                    filterExpr += " AND diff_builtup_area_sqft>50 ";


                    const ABPassLayer = new MapImageLayer({
                        url: "https://mpurbangis.in/server/rest/services/temp_n/abpas_property_mview/MapServer",
                        sublayers: [
                            {
                                id: 1, visible: true, definitionExpression: filterExpr,

                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "relation_id", label: "Relation Id  " },
                                                { fieldName: "ownername", label: "Owner Name " },
                                                { fieldName: "e_nagarpalikaid", label: "E-Nagar Palika Id " },
                                                { fieldName: "diff_builtup_area_sqft", label: "Difference Builtup area sqft   " },
                                                { fieldName: "diff_plot_area_sqft", label: "Difference Plot area sqft  " },
                                                { fieldName: "gis_no_of_floors", label: "Actual Floor in Ground " },
                                                { fieldName: "abpas_no_of_floors ", label: " Approved Floor in ABPAS " },
                                                { fieldName: "floor_status", label: "Floor Status " },
                                                { fieldName: "land_use_status", label: "Landuse Status " },
                                            ]
                                        },
                                        {
                                            type: "media",
                                            mediaInfos: [
                                                {
                                                    title: "<b>Property Photo</b>",
                                                    type: "image",
                                                    caption: "Linked to Relation ID",
                                                    value: {
                                                        sourceURL:
                                                            "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: "text",
                                            text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                        }
                                    ]
                                }//poptype close


                            },
                        ]
                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(ABPassLayer);


                    layerRef.current = ABPassLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: ABPassLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }

                    //  loadLayers();
                }// if end 



                if (key === "diff_plot_area_sqft>50" && view) {

                    // const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

                    let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                    // Add condition for remarks = 'Surveyed'
                    filterExpr += " AND diff_plot_area_sqft>50 ";


                    const ABPassLayer = new MapImageLayer({
                        url: "https://mpurbangis.in/server/rest/services/temp_n/abpas_property_mview/MapServer",
                        sublayers: [
                            {
                                id: 1, visible: true, definitionExpression: filterExpr,

                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "relation_id", label: "Relation ID" },
                                                { fieldName: "ownername", label: "Owner Name" },
                                                { fieldName: "e_nagarpalikaid", label: "E-Nagar Palika ID" },
                                                { fieldName: "diff_builtup_area_sqft", label: "Difference in Built-up Area (sqft)" },
                                                { fieldName: "diff_plot_area_sqft", label: "Difference in Plot Area (sqft)" },
                                                { fieldName: "gis_no_of_floors", label: "Actual Floor in Ground " },
                                                { fieldName: "abpas_no_of_floors ", label: " Approved Floor in ABPAS " },
                                                { fieldName: "floor_status", label: "Floor Status" },
                                                { fieldName: "land_use_status", label: "Land Use Status" }
                                            ]
                                        },
                                        {
                                            type: "media",
                                            mediaInfos: [
                                                {
                                                    title: "<b>Property Photo</b>",
                                                    type: "image",
                                                    caption: "Linked to Relation ID",
                                                    value: {
                                                        sourceURL: "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: "text",
                                            text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                        }
                                    ]
                                }





                            },
                        ]
                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(ABPassLayer);

                    layerRef.current = ABPassLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: ABPassLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }


                }// if end 


                if (key === "floor_status='Mismatch'" && view) {

                    // const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

                    let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                    // Add condition for remarks = 'Surveyed'
                    filterExpr += " AND floor_status='Mismatch'";


                    const ABPassLayer = new MapImageLayer({
                        url: "https://mpurbangis.in/server/rest/services/temp_n/abpas_property_mview/MapServer",
                        sublayers: [
                            {
                                id: 1, visible: true, definitionExpression: filterExpr,

                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "relation_id", label: "Relation Id  " },
                                                { fieldName: "ownername", label: "Owner Name " },
                                                { fieldName: "e_nagarpalikaid", label: "E-Nagar Palika Id " },
                                                { fieldName: "diff_builtup_area_sqft", label: "Difference Builtup area sqft   " },
                                                { fieldName: "diff_plot_area_sqft", label: "Difference Plot area sqft  " },
                                                { fieldName: "gis_no_of_floors", label: "Actual Floor in Ground " },
                                                { fieldName: "abpas_no_of_floors ", label: " Approved Floor in ABPAS " },


                                                { fieldName: "floor_status", label: "Floor Status " },
                                                { fieldName: "land_use_status", label: "Landuse Status " },


                                            ]
                                        },
                                        {
                                            type: "media",
                                            mediaInfos: [
                                                {
                                                    title: "<b>Property Photo</b>",
                                                    type: "image",
                                                    caption: "Linked to Relation ID",
                                                    value: {
                                                        sourceURL:
                                                            "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: "text",
                                            text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                        }
                                    ]
                                }//poptype close



                            },
                        ]
                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(ABPassLayer);


                    layerRef.current = ABPassLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: ABPassLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }


                }// if end 



                if (key === "land_use_status='Mismatch'" && view) {

                    // const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

                    let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                    // Add condition for remarks = 'Surveyed'
                    filterExpr += " AND land_use_status='Mismatch'";


                    const ABPassLayer = new MapImageLayer({
                        url: "https://mpurbangis.in/server/rest/services/temp_n/abpas_property_mview/MapServer",
                        sublayers: [
                            {
                                id: 1, visible: true, definitionExpression: filterExpr,

                                popupEnabled: true,
                                popupTemplate: {
                                    title: "Property ID: {relation_id}",
                                    content: [
                                        {
                                            type: "fields",
                                            fieldInfos: [
                                                { fieldName: "ulbname", label: "ULB Name" },
                                                { fieldName: "wardno", label: "Ward No" },
                                                { fieldName: "relation_id", label: "Relation Id  " },
                                                { fieldName: "ownername", label: "Owner Name " },
                                                { fieldName: "e_nagarpalikaid", label: "E-Nagar Palika Id " },
                                                { fieldName: "diff_builtup_area_sqft", label: "Difference Builtup area sqft   " },
                                                { fieldName: "diff_plot_area_sqft", label: "Difference Plot area sqft  " },

                                                { fieldName: "gis_no_of_floors", label: "Actual Floor in Ground " },
                                                { fieldName: "abpas_no_of_floors ", label: " Approved Floor in ABPAS " },

                                                { fieldName: "floor_status", label: "Floor Status " },
                                                { fieldName: "land_use_status", label: "Landuse Status " },


                                            ]
                                        },
                                        {
                                            type: "media",
                                            mediaInfos: [
                                                {
                                                    title: "<b>Property Photo</b>",
                                                    type: "image",
                                                    caption: "Linked to Relation ID",
                                                    value: {
                                                        sourceURL:
                                                            "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                    }
                                                }
                                            ]
                                        }
                                        ,
                                        {
                                            type: "text",
                                            text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                        }
                                    ]
                                }//poptype close





                            },
                        ]
                    });
                    const layer = new MapImageLayer({
                        url: mainLayerUrl,
                        sublayers: [adminLayer],
                    });

                    view.map.add(layer);
                    layerRef.current = layer;
                    // setView(mapView);
                    view.map.add(ABPassLayer);


                    layerRef.current = ABPassLayer;

                    // ✅ Update legend dynamically
                    if (legendWidgetRef.current) {
                        legendWidgetRef.current.layerInfos = [{
                            layer: ABPassLayer,
                            title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                        }];
                    }


                }// if end 
            }
            //{ key: 'govtassets', label: 'Govt. Asset', icon: <FaChartArea className="mr-2" size={20} /> },
            loadLayers(key);
        }
    };

    // BHUPENLAYER 

    // COMMON METHODS
    const loadLayers = (key) => {


        //alert(key);
        let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

        // code for defualt ADMIN LAYER

        const adminLayerDefualt = new MapImageLayer({
            url: mainLayerUrl,
            sublayers: adminSublayers.map((s) => ({
                id: s.id,
                title: s.title,
                visible: s.id === 1 || s.id === 3,
                definitionExpression: filterExpr, // ✅ only these two ON
            })),
        });
        secondLayerRef.current = adminLayerDefualt;
        view.map.add(adminLayerDefualt);

        // code for defualt ADMIN LAYER
        const adminLayer = new MapImageLayer({
            url: mainLayerUrl,
            sublayers: adminSublayers.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
            }))
        });
        secondLayerRef.current = adminLayer;
        view.map.add(adminLayer);

        // code for WATER_URL 2026 waterSublayers

        if (key === "water") {

            const WATER_layer = new MapImageLayer({
                url: WATER_URL,
                sublayers: waterSublayers.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: s.visible,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                    popupTemplate: {
                        title: "{layer}",   // 👈 layer shown as Name

                        content: [
                            {
                                type: "fields",
                                fieldInfos: [

                                    { fieldName: "layer", label: "Name" },

                                    { fieldName: "dist_nm", label: "District" },
                                    { fieldName: "ulb_nm", label: "ULB Name" },
                                    { fieldName: "ulb_cd", label: "ULB Code" },

                                    { fieldName: "capacity", label: "Capacity" },
                                    { fieldName: "status", label: "Status" },
                                    { fieldName: "completion", label: "Completion" },

                                    { fieldName: "cont_n", label: "Contractor" },

                                    { fieldName: "pr_nm", label: "Project Name" },
                                    { fieldName: "sc_nm", label: "Scheme Name" },

                                    { fieldName: "remark", label: "Remark" }

                                ]
                            }
                        ]
                    }

                }))
            });
            WaterLayerRef.current = WATER_layer;
            view.map.add(WATER_layer);

        }// if end 

        else {

            const WATER_layer = new MapImageLayer({
                url: WATER_URL,
                sublayers: waterSublayers.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                    popupTemplate: {
                        title: "{layer}",   // 👈 layer shown as Name

                        content: [
                            {
                                type: "fields",
                                fieldInfos: [

                                    { fieldName: "layer", label: "Name" },
                                    { fieldName: "dist_nm", label: "District" },
                                    { fieldName: "ulb_nm", label: "ULB Name" },
                                    { fieldName: "ulb_cd", label: "ULB Code" },
                                    { fieldName: "capacity", label: "Capacity" },
                                    { fieldName: "status", label: "Status" },
                                    { fieldName: "completion", label: "Completion" },
                                    { fieldName: "cont_n", label: "Contractor" },
                                    { fieldName: "pr_nm", label: "Project Name" },
                                    { fieldName: "sc_nm", label: "Scheme Name" },
                                    { fieldName: "remark", label: "Remark" }

                                ]
                            }
                        ]
                    }


                }))
            });
            WaterLayerRef.current = WATER_layer;
            view.map.add(WATER_layer);
        }

        //WTRBWaterURL
        const WTRBWaterURL_layer = new MapImageLayer({
            url: WTRBWaterURL,
            sublayers: WTRBWaterURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
            }))
        });
        WTRBWaterURLLayerRef.current = WTRBWaterURL_layer;
        view.map.add(WTRBWaterURL_layer);


        // code for Property 
        // Add PROPERTY_SUBLAYERS PROPERTY_URL


        // alert(key);    18JUN  
        if (key === "property") {

            // Add PROPERTY_SUBLAYERS PROPERTY_URL
          

           const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

const PROPERTY_layer = new MapImageLayer({
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/",
    sublayers: [
        {
            id: 14,
            title: "Property",
            visible: true,
            definitionExpression: filterExpr,

            popupEnabled: true,

            popupTemplate: {
                title: "🏠 Property Relation ID: {relation_id}",

                content: async (feature) => {

                    const attr = feature.graphic.attributes;
                    const PROPERTY_Relation_Id = attr.relation_id;

                    try {

                        const layer = new FeatureLayer({
                            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97"
                        });


                        const query = new Query({
                            where: `relation_id='${PROPERTY_Relation_Id}'`,
                            outFields: ["*"],
                            returnGeometry: false
                        });


                        const result = await layer.queryFeatures(query);

                        console.log("Result 👉", result);


                        if (!result.features || result.features.length === 0) {

                            return `
                            <div style="
                                color:red;
                                padding:15px;
                                background:#fff3f3;
                                border-radius:10px;
                            ">
                                ❌ No data found for ID: ${PROPERTY_Relation_Id}
                            </div>
                            `;
                        }


                        const data = result.features[0].attributes;


                        return `

<div style="
    font-family:sans-serif;
    height:920px;
    background:#eef6ff;
    padding:10px;
    border-radius:12px;
">


<div style="
    overflow-y:auto;
    height:100%;
    padding:5px;
     height:920px;
">


<!-- HEADER -->
<div style="
    background: linear-gradient(135deg, #073e48, #0b8c9e);
    color:white;
    padding:15px;
    border-radius:12px;
    margin-bottom:12px;    
    box-shadow:0 4px 12px rgba(0,0,0,.2);
">

<h2 style="margin:0;font-size:20px; color:white;">
🏠 Property Details
</h2>

</div>



<!-- OWNER CARD -->

<div style="
    background:white;
    border-radius:12px;
    padding:15px;
    margin-bottom:12px;
    box-shadow:0 3px 8px rgba(0,0,0,.15);
">


<h3 style="
    margin-top:0;
    color:#1976d2;
">
👤 Owner Information
</h3>



<table style="
    width:100%;
    border-collapse:collapse;
    font-size:14px;
     height:100%;
">


<tr style="background:#f5f9ff;">
<td style="padding:8px;border-bottom:1px solid #ddd;">
<b>E-Nagarpalika ID</b>
</td>
<td style="padding:8px;border-bottom:1px solid #ddd;">
${data.e_nagarpalikaid || "-"}
</td>
</tr>


<tr>
<td style="padding:8px;border-bottom:1px solid #ddd;">
<b>ULB Name</b>
</td>
<td style="padding:8px;border-bottom:1px solid #ddd;">
${data.ulbname || "-"}
</td>
</tr>



<tr style="background:#f5f9ff;">
<td style="padding:8px;border-bottom:1px solid #ddd;">
<b>Ward No</b>
</td>
<td style="padding:8px;border-bottom:1px solid #ddd;">
${data.wardno || "-"}
</td>
</tr>



<tr>
<td style="padding:8px;border-bottom:1px solid #ddd;">
<b>Ward Name</b>
</td>
<td style="padding:8px;border-bottom:1px solid #ddd;">
${data.wardname || "-"}
</td>
</tr>



<tr style="background:#f5f9ff;">
<td style="padding:8px;border-bottom:1px solid #ddd;">
<b>Name</b>
</td>
<td style="padding:8px;border-bottom:1px solid #ddd;">
${data.ownername || "-"}
</td>
</tr>



<tr>
<td style="padding:8px;border-bottom:1px solid #ddd;">
<b>Guardian</b>
</td>
<td style="padding:8px;border-bottom:1px solid #ddd;">
${data.ownergardianname || "-"}
</td>
</tr>



<tr style="background:#f5f9ff;">
<td style="padding:8px;">
<b>Mobile</b>
</td>
<td style="padding:8px;">
${data.mobileno || "-"}
</td>
</tr>


</table>

</div>





<!-- IMAGE CARD -->

<div style="
    background:white;
    border-radius:12px;
    padding:15px;
     height:100%;
    text-align:center;
    box-shadow:0 3px 8px rgba(0,0,0,.15);
">


<h3 style="
color:#00a651;
margin-top:0;
">
📸 Property Photo
</h3>



<img
src="https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${PROPERTY_Relation_Id}"
style="
width:100%;
height:420px;
object-fit:cover;
border-radius:10px;
border:2px solid #ddd;
"
onerror="
this.style.display='none';
this.parentNode.innerHTML += 
'<div style=color:red;padding:15px>No Image Found</div>';
"
/>


</div>



</div>

</div>

`;

                    }
                    catch(error){

                        console.error(error);

                        return `
                        <div style="
                            color:red;
                            background:#fff0f0;
                            padding:10px;
                            border-radius:8px;
                        ">
                        ❌ Failed to load property details
                        </div>
                        `;
                    }

                }
            }
        }
    ]
});


view.map.add(PROPERTY_layer);

PropertierLayerRef.current = PROPERTY_layer;

            // code for Property 

        }// if end 

        else {

            // Add PROPERTY_SUBLAYERS PROPERTY_URL
            const PROPERTY_layer = new MapImageLayer({
                url: PROPERTY_URL,
                sublayers: PROPERTY_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    
                    definitionExpression: filterExpr
                }))
            });
            PropertierLayerRef.current = PROPERTY_layer;
            view.map.add(PROPERTY_layer);

            // code for Property 
        }

        // code for property 

        // BASE  MAP
        checkULBExists(ulbCode).then(exists => {
            if (exists) {
                const BaseMapLayer = new MapImageLayer({
                    url: BaseMapURL,
                    sublayers: BaseMapURLURL_sublayer.map((s) => ({
                        id: s.id,
                        title: s.title,
                        visible: s.visible,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                    }))
                });
                BasemapLayerRef.current = BaseMapLayer;
                view.map.add(BaseMapLayer);

            } else {

            }
        });


        // BASED MAP

        const BaseMapLayer = new MapImageLayer({
            url: BaseMapURL,
            sublayers: BaseMapURLURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr
            }))
        });
        BasemapLayerRef.current = BaseMapLayer;
        view.map.add(BaseMapLayer);

        //  Add PROPERTY_SUBLAYERS PROPERTY_URL
        //  MPLanduseLayerRef
        const MPLanduse = new MapImageLayer({
            url: MPLanduse_URL,
            sublayers: MPLanduse_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
            }))
        });
        MPLanduseLayerRef.current = MPLanduse;
        view.map.add(MPLanduse);
        // code for LandSuitabilityURLLayerRef
        const LandSuitabilityURL_layer = new MapImageLayer({
            url: LandSuitabilityURL,
            sublayers: LandSuitabilityURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
            }))
        });
        LandSuitabilityURLLayerRef.current = LandSuitabilityURL_layer;
        view.map.add(LandSuitabilityURL_layer);

        // end code for LandSuitabilityURLLayerRef
        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

        if (activeSubTabCard === "2") {
            //filterExpr += " AND description = 'Central Government Assets'"; 
        }

        // code for GOVT govtassets
        if (key === "govtassets") {
            //Municipal Assets   if (selectedTitle === "State Govt")
            if (selectedTitle === "Center Govt") {
                const AssestsCentralLayer = new MapImageLayer({
                    url: ASSETS_URL1,
                    sublayers: ASSETS_Central_SUBLAYERS.map((s) => ({
                        id: 2,
                        title: 'Center Govt',
                        visible: true,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{name}",

                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [

                                        { fieldName: "objectid", label: "Object ID" },

                                        { fieldName: "districtname", label: "District" },
                                        { fieldName: "ulbname", label: "ULB" },
                                        { fieldName: "zoneno", label: "Zone No" },
                                        { fieldName: "wardno", label: "Ward No" },
                                        { fieldName: "wardname", label: "Ward Name" },

                                        { fieldName: "name", label: "Name" },
                                        { fieldName: "type", label: "Type" },
                                        { fieldName: "description", label: "Description" },

                                        {
                                            fieldName: "latitude",
                                            label: "Latitude",
                                            format: { places: 6 }
                                        },
                                        {
                                            fieldName: "longitude",
                                            label: "Longitude",
                                            format: { places: 6 }
                                        },

                                        { fieldName: "remark", label: "Remark" }

                                    ]
                                }
                            ]
                        }
                    }))
                });
                ASSETS_CentralLayerRef.current = AssestsCentralLayer;
                view.map.add(AssestsCentralLayer);
            }
            else if (selectedTitle === "State Govt") {
                const AssestsCentralLayer = new MapImageLayer({
                    url: ASSETS_URL1,
                    sublayers: ASSETS_Central_SUBLAYERS.map((s) => ({
                        id: 3,
                        title: 'State Govt',
                        visible: true,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{name}",
                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [
                                        { fieldName: "objectid", label: "Object ID" },
                                        { fieldName: "districtname", label: "District" },
                                        { fieldName: "ulbname", label: "ULB" },
                                        { fieldName: "zoneno", label: "Zone No" },
                                        { fieldName: "wardno", label: "Ward No" },
                                        { fieldName: "wardname", label: "Ward Name" },
                                        { fieldName: "name", label: "Name" },
                                        { fieldName: "type", label: "Type" },
                                        { fieldName: "description", label: "Description" },
                                        { fieldName: "latitude", label: "Latitude", format: { places: 6 }},
                                        { fieldName: "longitude", label: "Longitude", format: { places: 6 }},
                                        { fieldName: "remark", label: "Remark" }
                                    ]
                                }
                            ]
                        }
                    }))
                });
                ASSETS_CentralLayerRef.current = AssestsCentralLayer;
                view.map.add(AssestsCentralLayer);

            }
            else if (selectedTitle === "Municipal Assets") {
                const AssestsCentralLayer = new MapImageLayer({
                    url: ASSETS_URL1,
                    sublayers: ASSETS_Central_SUBLAYERS.map((s) => ({
                        id: 4,
                        title: 'Municipal Assets',
                        visible: true,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{name}",

                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [

                                        { fieldName: "objectid", label: "Object ID" },

                                        { fieldName: "districtname", label: "District" },
                                        { fieldName: "ulbname", label: "ULB" },
                                        { fieldName: "zoneno", label: "Zone No" },
                                        { fieldName: "wardno", label: "Ward No" },
                                        { fieldName: "wardname", label: "Ward Name" },

                                        { fieldName: "name", label: "Name" },
                                        { fieldName: "type", label: "Type" },
                                        { fieldName: "description", label: "Description" },

                                        {
                                            fieldName: "latitude",
                                            label: "Latitude",
                                            format: { places: 6 }
                                        },
                                        {
                                            fieldName: "longitude",
                                            label: "Longitude",
                                            format: { places: 6 }
                                        },

                                        { fieldName: "remark", label: "Remark" }

                                    ]
                                }
                            ]
                        }
                    }))
                });
                ASSETS_CentralLayerRef.current = AssestsCentralLayer;
                view.map.add(AssestsCentralLayer);
            }
            else {
                const AssestsCentralLayer = new MapImageLayer({
                    url: ASSETS_URL1,
                    sublayers: ASSETS_Central_SUBLAYERS.map((s) => ({
                        id: s.id,
                        title: s.title,
                        visible: true,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{name}",

                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [

                                        { fieldName: "objectid", label: "Object ID" },

                                        { fieldName: "districtname", label: "District" },
                                        { fieldName: "ulbname", label: "ULB" },
                                        { fieldName: "zoneno", label: "Zone No" },
                                        { fieldName: "wardno", label: "Ward No" },
                                        { fieldName: "wardname", label: "Ward Name" },

                                        { fieldName: "name", label: "Name" },
                                        { fieldName: "type", label: "Type" },
                                        { fieldName: "description", label: "Description" },

                                        {
                                            fieldName: "latitude",
                                            label: "Latitude",
                                            format: { places: 6 }
                                        },
                                        {
                                            fieldName: "longitude",
                                            label: "Longitude",
                                            format: { places: 6 }
                                        },

                                        { fieldName: "remark", label: "Remark" }

                                    ]
                                }
                            ]
                        }
                    }))
                });
                ASSETS_CentralLayerRef.current = AssestsCentralLayer;
                view.map.add(AssestsCentralLayer);

            }

        }// if end 
        else {
            const AssestsCentralLayer = new MapImageLayer({
                url: ASSETS_URL1,
                sublayers: ASSETS_Central_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                    popupTemplate: {
                        title: "{name}",

                        content: [
                            {
                                type: "fields",
                                fieldInfos: [

                                    { fieldName: "objectid", label: "Object ID" },
                                    { fieldName: "districtname", label: "District" },
                                    { fieldName: "ulbname", label: "ULB" },
                                    { fieldName: "zoneno", label: "Zone No" },
                                    { fieldName: "wardno", label: "Ward No" },
                                    { fieldName: "wardname", label: "Ward Name" },
                                    { fieldName: "name", label: "Name" },
                                    { fieldName: "type", label: "Type" },
                                    { fieldName: "description", label: "Description" },
                                    {
                                        fieldName: "latitude",
                                        label: "Latitude",
                                        format: { places: 6 }
                                    },
                                    {
                                        fieldName: "longitude",
                                        label: "Longitude",
                                        format: { places: 6 }
                                    },

                                    { fieldName: "remark", label: "Remark" }

                                ]
                            }
                        ]
                    }
                }))
            });
            ASSETS_CentralLayerRef.current = AssestsCentralLayer;
            view.map.add(AssestsCentralLayer);
        }


        // CODE  FOR SBM   MISSION
        // alert(key);
        if (key === "sbm") {
            //Municipal Assets   if (selectedTitle === "State Govt")
            if (selectedTitle === "sbm") {
                const SBMLayer = new MapImageLayer({
                    url: SBM_URL1,
                    sublayers: SBM_SUBLAYERS.map((s) => ({
                        id: 1,
                        title: 'Processing Plant',
                        visible: true,
                        //  BHUPEN  CODE 
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{plant_name}",

                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [

                                        // 🔹 Basic Info
                                        { fieldName: "objectid", label: "Object ID" },
                                        { fieldName: "sno", label: "S. No" },

                                        // 🔹 Location
                                        { fieldName: "district_name", label: "District" },
                                        { fieldName: "ulbname", label: "ULB Name" },
                                        { fieldName: "ward_number", label: "Ward Number" },
                                        { fieldName: "wardname", label: "Ward Name" },

                                        // 🔹 Plant Details
                                        { fieldName: "plant_name", label: "Plant Name" },
                                        { fieldName: "facilitytypename", label: "Facility Type" },
                                        { fieldName: "planttype", label: "Plant Type" },
                                        { fieldName: "subcategory", label: "Sub Category" },
                                        { fieldName: "misplantid", label: "MIS Plant ID" },

                                        // 🔹 Status & Capacity
                                        { fieldName: "plantstatus", label: "Plant Status" },
                                        {
                                            fieldName: "designcapacity_tons",
                                            label: "Capacity (Tons)",
                                            format: { digitSeparator: true }
                                        },

                                        // 🔹 Address
                                        { fieldName: "address", label: "Address" },
                                        { fieldName: "landmark", label: "Landmark" },
                                        { fieldName: "pincode", label: "Pincode" },

                                        // 🔹 Coordinates
                                        { fieldName: "latitude", label: "Latitude", format: { places: 6 } },
                                        { fieldName: "longitude", label: "Longitude", format: { places: 6 } },

                                        // 🔹 Financial
                                        {
                                            fieldName: "projectcost",
                                            label: "Project Cost",
                                            format: { digitSeparator: true }
                                        },
                                        { fieldName: "fundedby", label: "Funded By" },

                                        // 🔹 Ownership
                                        { fieldName: "ownedby", label: "Owned By" },
                                        { fieldName: "operatedby", label: "Operated By" },
                                        { fieldName: "ownedbyprivate", label: "Private Owner" },
                                        { fieldName: "operatedbyprivate", label: "Private Operator" },

                                        // 🔹 System Info
                                        { fieldName: "isintegrated", label: "Integrated" },
                                        { fieldName: "iscentralised", label: "Centralised" },
                                        { fieldName: "ictmonitoring", label: "ICT Monitoring" },
                                        { fieldName: "personengaged", label: "Persons Engaged" },

                                        // 🔹 Codes
                                        { fieldName: "dist_cd", label: "District Code" },
                                        { fieldName: "ulb_cd", label: "ULB Code" },
                                        { fieldName: "wardno", label: "Ward Code" },
                                        { fieldName: "ulb_lgdcode", label: "ULB LGD Code" },
                                        { fieldName: "ulb_id", label: "ULB ID" },
                                        { fieldName: "id", label: "ID" },

                                        // 🔹 Remarks
                                        { fieldName: "remark", label: "Remark" }

                                    ]
                                }
                            ]
                        }

                    }))
                });
                SMBLayerRef.current = SBMLayer;
                view.map.add(SBMLayer);
            }
            else if (selectedTitle === "Dump Site") {
                const DumpSitelLayer = new MapImageLayer({
                    url: SBM_URL1,
                    sublayers: SBM_SUBLAYERS.map((s) => ({
                        id: 2,
                        title: 'Dump Site',
                        visible: true,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{plant_name}",

                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [

                                        // 🔹 Basic Info
                                        { fieldName: "objectid", label: "Object ID" },
                                        { fieldName: "sno", label: "S. No" },

                                        // 🔹 Location
                                        { fieldName: "district_name", label: "District" },
                                        { fieldName: "ulbname", label: "ULB Name" },
                                        { fieldName: "ward_number", label: "Ward Number" },
                                        { fieldName: "wardname", label: "Ward Name" },

                                        // 🔹 Plant Details
                                        { fieldName: "plant_name", label: "Plant Name" },
                                        { fieldName: "facilitytypename", label: "Facility Type" },
                                        { fieldName: "planttype", label: "Plant Type" },
                                        { fieldName: "subcategory", label: "Sub Category" },
                                        { fieldName: "misplantid", label: "MIS Plant ID" },

                                        // 🔹 Status & Capacity
                                        { fieldName: "plantstatus", label: "Plant Status" },
                                        {
                                            fieldName: "designcapacity_tons",
                                            label: "Capacity (Tons)",
                                            format: { digitSeparator: true }
                                        },

                                        // 🔹 Address
                                        { fieldName: "address", label: "Address" },
                                        { fieldName: "landmark", label: "Landmark" },
                                        { fieldName: "pincode", label: "Pincode" },

                                        // 🔹 Coordinates
                                        { fieldName: "latitude", label: "Latitude", format: { places: 6 } },
                                        { fieldName: "longitude", label: "Longitude", format: { places: 6 } },

                                        // 🔹 Financial
                                        {
                                            fieldName: "projectcost",
                                            label: "Project Cost",
                                            format: { digitSeparator: true }
                                        },
                                        { fieldName: "fundedby", label: "Funded By" },

                                        // 🔹 Ownership
                                        { fieldName: "ownedby", label: "Owned By" },
                                        { fieldName: "operatedby", label: "Operated By" },
                                        { fieldName: "ownedbyprivate", label: "Private Owner" },
                                        { fieldName: "operatedbyprivate", label: "Private Operator" },

                                        // 🔹 System Info
                                        { fieldName: "isintegrated", label: "Integrated" },
                                        { fieldName: "iscentralised", label: "Centralised" },
                                        { fieldName: "ictmonitoring", label: "ICT Monitoring" },
                                        { fieldName: "personengaged", label: "Persons Engaged" },

                                        // 🔹 Codes
                                        { fieldName: "dist_cd", label: "District Code" },
                                        { fieldName: "ulb_cd", label: "ULB Code" },
                                        { fieldName: "wardno", label: "Ward Code" },
                                        { fieldName: "ulb_lgdcode", label: "ULB LGD Code" },
                                        { fieldName: "ulb_id", label: "ULB ID" },
                                        { fieldName: "id", label: "ID" },

                                        // 🔹 Remarks
                                        { fieldName: "remark", label: "Remark" }

                                    ]
                                }
                            ]
                        }
                    }))
                });
                SMBLayerRef.current = DumpSitelLayer;
                view.map.add(DumpSitelLayer);

            }
            else if (selectedTitle === "Landfill") {
                const LandfillLayer = new MapImageLayer({
                    url: SBM_URL1,
                    sublayers: SBM_SUBLAYERS.map((s) => ({
                        id: 3,
                        title: 'Landfill',
                        visible: true,
                        definitionExpression: filterExpr,
                        popupEnabled: true,
                        popupTemplate: {
                            title: "{plant_name}",

                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [

                                        // 🔹 Basic Info
                                        { fieldName: "objectid", label: "Object ID" },
                                        { fieldName: "sno", label: "S. No" },

                                        // 🔹 Location
                                        { fieldName: "district_name", label: "District" },
                                        { fieldName: "ulbname", label: "ULB Name" },
                                        { fieldName: "ward_number", label: "Ward Number" },
                                        { fieldName: "wardname", label: "Ward Name" },

                                        // 🔹 Plant Details
                                        { fieldName: "plant_name", label: "Plant Name" },
                                        { fieldName: "facilitytypename", label: "Facility Type" },
                                        { fieldName: "planttype", label: "Plant Type" },
                                        { fieldName: "subcategory", label: "Sub Category" },
                                        { fieldName: "misplantid", label: "MIS Plant ID" },

                                        // 🔹 Status & Capacity
                                        { fieldName: "plantstatus", label: "Plant Status" },
                                        {
                                            fieldName: "designcapacity_tons",
                                            label: "Capacity (Tons)",
                                            format: { digitSeparator: true }
                                        },

                                        // 🔹 Address
                                        { fieldName: "address", label: "Address" },
                                        { fieldName: "landmark", label: "Landmark" },
                                        { fieldName: "pincode", label: "Pincode" },

                                        // 🔹 Coordinates
                                        { fieldName: "latitude", label: "Latitude", format: { places: 6 } },
                                        { fieldName: "longitude", label: "Longitude", format: { places: 6 } },

                                        // 🔹 Financial
                                        {
                                            fieldName: "projectcost",
                                            label: "Project Cost",
                                            format: { digitSeparator: true }
                                        },
                                        { fieldName: "fundedby", label: "Funded By" },

                                        // 🔹 Ownership
                                        { fieldName: "ownedby", label: "Owned By" },
                                        { fieldName: "operatedby", label: "Operated By" },
                                        { fieldName: "ownedbyprivate", label: "Private Owner" },
                                        { fieldName: "operatedbyprivate", label: "Private Operator" },

                                        // 🔹 System Info
                                        { fieldName: "isintegrated", label: "Integrated" },
                                        { fieldName: "iscentralised", label: "Centralised" },
                                        { fieldName: "ictmonitoring", label: "ICT Monitoring" },
                                        { fieldName: "personengaged", label: "Persons Engaged" },

                                        // 🔹 Codes
                                        { fieldName: "dist_cd", label: "District Code" },
                                        { fieldName: "ulb_cd", label: "ULB Code" },
                                        { fieldName: "wardno", label: "Ward Code" },
                                        { fieldName: "ulb_lgdcode", label: "ULB LGD Code" },
                                        { fieldName: "ulb_id", label: "ULB ID" },
                                        { fieldName: "id", label: "ID" },

                                        // 🔹 Remarks
                                        { fieldName: "remark", label: "Remark" }

                                    ]
                                }
                            ]
                        }
                    }))
                });
                SMBLayerRef.current = LandfillLayer;
                view.map.add(LandfillLayer);
            }
            else {
                const SBMLayer = new MapImageLayer({
                    url: SBM_URL1,
                    sublayers: SBM_SUBLAYERS.map((s) => ({
                        id: s.id,
                        title: s.title,
                        visible: true,
                        definitionExpression: filterExpr,
                        outFields: ["*"],
                        popupEnabled: true,
                        popupTemplate: {
                            title: "Processing Plant Details",
                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [
                                        { fieldName: "districtname", label: "District Name" },
                                        { fieldName: "ulbname", label: "ULB Name" },
                                        { fieldName: "plant_name", label: "Plant Name" },
                                        { fieldName: "planttype", label: "Plant Type" },
                                        { fieldName: "subcategory", label: "Sub Category" },
                                        { fieldName: "ownedby", label: "Owned By" },
                                        { fieldName: "fundedby", label: "Funded By" },
                                        { fieldName: "operatedby", label: "Operated By" },
                                        { fieldName: "plantstatus", label: "Plant Status" },

                                    ]
                                }
                            ]
                        }
                    }))
                });
                SMBLayerRef.current = SBMLayer;
                view.map.add(SBMLayer);
            }

        }// if end 
        else {
            const SBMLayer = new MapImageLayer({
                url: SBM_URL1,
                sublayers: SBM_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                    popupTemplate: {
                        title: "{plant_name}",

                        content: [
                            {
                                type: "fields",
                                fieldInfos: [

                                    // 🔹 Basic Info
                                    { fieldName: "objectid", label: "Object ID" },
                                    { fieldName: "sno", label: "S. No" },

                                    // 🔹 Location
                                    { fieldName: "district_name", label: "District" },
                                    { fieldName: "ulbname", label: "ULB Name" },
                                    { fieldName: "ward_number", label: "Ward Number" },
                                    { fieldName: "wardname", label: "Ward Name" },

                                    // 🔹 Plant Details
                                    { fieldName: "plant_name", label: "Plant Name" },
                                    { fieldName: "facilitytypename", label: "Facility Type" },
                                    { fieldName: "planttype", label: "Plant Type" },
                                    { fieldName: "subcategory", label: "Sub Category" },
                                    { fieldName: "misplantid", label: "MIS Plant ID" },

                                    // 🔹 Status & Capacity
                                    { fieldName: "plantstatus", label: "Plant Status" },
                                    {
                                        fieldName: "designcapacity_tons",
                                        label: "Capacity (Tons)",
                                        format: { digitSeparator: true }
                                    },

                                    // 🔹 Address
                                    { fieldName: "address", label: "Address" },
                                    { fieldName: "landmark", label: "Landmark" },
                                    { fieldName: "pincode", label: "Pincode" },

                                    // 🔹 Coordinates
                                    { fieldName: "latitude", label: "Latitude", format: { places: 6 } },
                                    { fieldName: "longitude", label: "Longitude", format: { places: 6 } },

                                    // 🔹 Financial
                                    {
                                        fieldName: "projectcost",
                                        label: "Project Cost",
                                        format: { digitSeparator: true }
                                    },
                                    { fieldName: "fundedby", label: "Funded By" },

                                    // 🔹 Ownership
                                    { fieldName: "ownedby", label: "Owned By" },
                                    { fieldName: "operatedby", label: "Operated By" },
                                    { fieldName: "ownedbyprivate", label: "Private Owner" },
                                    { fieldName: "operatedbyprivate", label: "Private Operator" },

                                    // 🔹 System Info
                                    { fieldName: "isintegrated", label: "Integrated" },
                                    { fieldName: "iscentralised", label: "Centralised" },
                                    { fieldName: "ictmonitoring", label: "ICT Monitoring" },
                                    { fieldName: "personengaged", label: "Persons Engaged" },

                                    // 🔹 Codes
                                    { fieldName: "dist_cd", label: "District Code" },
                                    { fieldName: "ulb_cd", label: "ULB Code" },
                                    { fieldName: "wardno", label: "Ward Code" },
                                    { fieldName: "ulb_lgdcode", label: "ULB LGD Code" },
                                    { fieldName: "ulb_id", label: "ULB ID" },
                                    { fieldName: "id", label: "ID" },

                                    // 🔹 Remarks
                                    { fieldName: "remark", label: "Remark" }

                                ]
                            }
                        ]
                    }
                }))
            });
            SMBLayerRef.current = SBMLayer;
            view.map.add(SBMLayer);
        }
        // CODE  FOR SBM   MISSION

        //  AMRUT2.0
        const AMRUT_layer = new MapImageLayer({
            url: AMRUT_URL,
            sublayers: AMRUT_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                outFields: ["*"],
                popupEnabled: true,
                popupTemplate: {
                    title: "{pr_nm}",
                    content: [
                        {
                            type: "text",
                            text: `
      <div style="
        background:linear-gradient(135deg,#2c3e50,#4ca1af);
        color:white;
        padding:15px;
        border-radius:10px;
        font-family:Arial;
        position:relative;
        text-align:left;
        max-height:580px;
        overflow-y:auto;
      ">

      <!-- Header -->
      <h3 style="
        margin:0 0 10px 0;
        border-bottom:1px solid rgba(255,255,255,0.4);
        padding-bottom:5px;
        color:white;
      ">
        Project Information
      </h3>

      <table style="
        width:100%;
        border-collapse:collapse;
        font-size:13px;
      ">

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">District Name</td>
        <td style="padding:6px;">{dist_nm}</td>
      </tr>

      <tr style="background:rgba(255,255,255,0.05)">
        <td style="padding:6px;color:#ffd166;font-weight:bold;">ULB Name</td>
        <td style="padding:6px;">{ulb_nm}</td>
      </tr>

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Ward Name</td>
        <td style="padding:6px;">{wardname}</td>
      </tr>

      <tr style="background:rgba(255,255,255,0.05)">
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Contractor Name</td>
        <td style="padding:6px;">{cont_nm}</td>
      </tr>

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Location</td>
        <td style="padding:6px;">{location}</td>
      </tr>

      <tr style="background:rgba(255,255,255,0.05)">
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Scheme Name</td>
        <td style="padding:6px;">{scheme_nm}</td>
      </tr>

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Scheme ID</td>
        <td style="padding:6px;">{scheme_id}</td>
      </tr>

      <tr style="background:rgba(255,255,255,0.05)">
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Package ID</td>
        <td style="padding:6px;">{pkg_id}</td>
      </tr>

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Waterbody Name</td>
        <td style="padding:6px;">{name_wb}</td>
      </tr>

      <tr style="background:rgba(255,255,255,0.05)">
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Area of Waterbody</td>
        <td style="padding:6px;">{wbr_area}</td>
      </tr>

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Area (sqm)</td>
        <td style="padding:6px;">{wbr_area_sqm}</td>
      </tr>

      <tr style="background:rgba(255,255,255,0.05)">
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Project Name</td>
        <td style="padding:6px;">{pr_nm}</td>
      </tr>

      <tr>
        <td style="padding:6px;color:#ffd166;font-weight:bold;">Remark</td>
        <td style="padding:6px;">{remark}</td>
      </tr>

      </table>
      </div>
      `
                        }
                    ]
                }
            }))
        });
        AMRUTLayerRef.current = AMRUT_layer;
        view.map.add(AMRUT_layer);
        //  AMRUT2.0









        //StormWaterURL
        const StormWaterURL_layer = new MapImageLayer({
            url: StormWaterURL,
            sublayers: StormWaterURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
            }))
        });
        StormWaterURLLayerRef.current = StormWaterURL_layer;
        view.map.add(StormWaterURL_layer);



        //  stormWaterURLLegends
        //  alert(key);
        //  transportation 

        if (key === "transportation") {

            filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
            const Transportation = new MapImageLayer({
                url: Transportation_URL,
                sublayers: Transportation_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: s.visible,
                    definitionExpression: filterExpr
                }))
            });
            TransportationLayerRef.current = Transportation;
            view.map.add(Transportation);

            checkULBExists(ulbCode).then(exists => {
                if (exists) {
                    //alert("BaseMapURL for Transportation Processing.....");
                    const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                    const Trasportlayer = new MapImageLayer({
                        url: BaseMapURL,
                        sublayers: [
                            { id: 45, title: "Roads", visible: true, definitionExpression: filterExpr },
                            { id: 56, title: "Railway", visible: true, definitionExpression: filterExpr },

                        ]
                    });
                    view.map.add(Trasportlayer);
                    layerRef.current = Trasportlayer;


                }
            });

        }
        else {
            filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
            const Transportation = new MapImageLayer({
                url: Transportation_URL,
                sublayers: Transportation_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                }))
            });
            TransportationLayerRef.current = Transportation;
            view.map.add(Transportation);
        }
        if (key === "sewerage") {

            // Add Sampda Guideline Layer 
            filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
            const SEWER_SUBLAYERSLayer = new MapImageLayer({
                url: SEWER_URL,
                sublayers: SEWER_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: s.visible,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                }))
            });
            SEWRAGELayerRef.current = SEWER_SUBLAYERSLayer;
            view.map.add(SEWER_SUBLAYERSLayer);

        }
        else {
            filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
            const SEWER_SUBLAYERSLayer = new MapImageLayer({
                url: SEWER_URL,
                sublayers: SEWER_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    definitionExpression: filterExpr,
                    popupEnabled: true,
                }))
            });
            SEWRAGELayerRef.current = SEWER_SUBLAYERSLayer;
            view.map.add(SEWER_SUBLAYERSLayer);

        }
        // Add Sampda Guideline Layer
        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        const sampdaGuidelineLayer = new MapImageLayer({
            url: SAMPDA_GUIDELINE_URL,
            sublayers: SAMPDA_GUIDELINE_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
            }))
        });
        sampdaGuidelineLayerRef.current = sampdaGuidelineLayer;
        view.map.add(sampdaGuidelineLayer);




        //  BHUPEN STEP 5 

        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        const GreenSpacesLayer = new MapImageLayer({
            url: GreenSpacesURL,
            sublayers: GreenSpacesURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,

            }))
        });
        GreenSpacesURLLayerRef.current = GreenSpacesLayer;
        view.map.add(GreenSpacesLayer);




        //LEFT LAYER TABEL  MASTERPLANB 

        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        const masterPlanLayer = new MapImageLayer({
            url: MASTER_PLAN_URL,
            sublayers: MASTER_PLAN_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,

            }))
        });
        masterPlanLayerRef.current = masterPlanLayer;
        view.map.add(masterPlanLayer);

        //LEFT MANU LAYER TABLE   

        // AAI_URL ,  AAI_SUBLAYERS   , AAILayerRef
        // const [showAAI, setshowAAI] = useState(false);   
        // const AAILayerRef = useRef(null);
        // const [AAILegends, setAAILegends] = useState({});

        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

        const AAIURL_layer = new MapImageLayer({
            url: AAI_URL,
            sublayers: AAI_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
                popupTemplate: {
                    title: "✈️ Airport Details",

                    content: [
                        {
                            type: "text",
                            text: `
        <div style="height:260px; overflow-y:auto; padding:6px;">

          <table class="one-table">

            <!-- 🔵 MAIN HEADER -->
            <tr class="main-header">
              <td colspan="2">{airportname}</td>
            </tr>

            <!-- 📍 LOCATION -->
            <tr class="section"><td colspan="2">📍 Location Info</td></tr>
            <tr><td>District</td><td>{districtname}</td></tr>
            <tr><td>ULB</td><td>{ulbname}</td></tr>
            <tr><td>ULB Code</td><td>{ulb_cd}</td></tr>
            <tr><td>District Code</td><td>{dist_cd}</td></tr>

            <!-- ✈️ AIRPORT -->
            <tr class="section"><td colspan="2">✈️ Airport Info</td></tr>
            <tr><td>Airport Name</td><td>{airportname}</td></tr>
            <tr><td>Grid Name</td><td>{gridname}</td></tr>
            <tr><td>Permissible Elevation</td><td>{permissible_top_elev} m</td></tr>

            <!-- 📊 HEIGHT -->
            <tr class="section"><td colspan="2">📊 Height Analysis</td></tr>
            <tr><td>Min Elevation</td><td>{z_min}</td></tr>
            <tr><td>Max Elevation</td><td>{z_max}</td></tr>
            <tr><td>Mean Elevation</td><td>{z_mean}</td></tr>

            <!-- 📐 AREA -->
            <tr class="section"><td colspan="2">📐 Area Info</td></tr>
            <tr><td>Area (SqKm)</td><td>{area_sqkm}</td></tr>
            <tr><td>Area (Sqm)</td><td>{area_sqm}</td></tr>
            <tr><td>Shape Area</td><td>{st_area(shape)}</td></tr>
            <tr><td>Shape Length</td><td>{st_length(shape)}</td></tr>

            <!-- 🏢 BUILDING -->
            <tr class="section"><td colspan="2">🏢 Building Permission</td></tr>
            <tr><td>Height</td><td>{permi_build_hgt} m</td></tr>
            <tr><td>Floors</td><td>{permi_no_of_fl}</td></tr>

          </table>

        </div>
      `
                        }
                    ]
                }



            }))
        });
        AAILayerRef.current = AAIURL_layer;
        view.map.add(AAIURL_layer);




        // Monuments_URL ,  Monuments_SUBLAYERS 
        // const  MonumentsLayerRef = useRef(null);
        // const [MonumentsLegends, setMonumentsLegends] = useState({});   
        // const [showMonuments, setshowMonuments] = useState(false);

        const MonumentsURL_layer = new MapImageLayer({
            url: Monuments_URL,
            sublayers: Monuments_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
                popupTemplate: {
                    title: `${s.title} - {name}`,

                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                { fieldName: "objectid", label: "OBJECT ID" },
                                { fieldName: "name", label: "Name" },
                                { fieldName: "lgd_ulb_cd", label: "LGD ULB Code" },
                                { fieldName: "ulbname", label: "ULB Name" },
                                { fieldName: "statename", label: "State Name" },
                                { fieldName: "divisionname", label: "Division Name" },
                                { fieldName: "districtname", label: "District Name" },
                                { fieldName: "ulbtype", label: "ULB Type" },
                                { fieldName: "statecode", label: "State Code" },
                                { fieldName: "div_cd", label: "Division Code" },
                                { fieldName: "dist_cd", label: "District Code" },
                                { fieldName: "ulb_cd", label: "ULB Code" },
                                { fieldName: "locality", label: "Locality" },
                                { fieldName: "asi_circle", label: "ASI Circle" },
                                { fieldName: "asi_regional_director", label: "ASI Regional Director" },

                                // Coordinates
                                { fieldName: "latitude", label: "Latitude" },
                                { fieldName: "longitude", label: "Longitude" }
                            ],  //  SCROLL ENABLE
                            style: {
                                maxHeight: "350px",
                                overflow: "auto"
                            }
                        }
                    ]
                }
            }))
        });
        MonumentsLayerRef.current = MonumentsURL_layer;
        view.map.add(MonumentsURL_layer);


        // HousingBoard_URL  ,   HousingBoard_SUBLAYERS
        // const  HousingBoardLayerRef = useRef(null);
        // const [HousingBoardLegends, setHousingBoardLegends] = useState({});   
        // const [showHousingBoard, setshowHousingBoard] = useState(false);

        const HousingBoardURL_layer = new MapImageLayer({
            url: HousingBoard_URL,
            sublayers: HousingBoard_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
                popupTemplate: {
                    title: `${s.title} - {colony_name}`,

                    content: (feature) => {
                        const attrs = feature.graphic.attributes;

                        return `
      <div style="max-height:320px; overflow:auto;">
        <table style="width:100%; border-collapse:collapse; font-size:12px;">
          <thead>
            <tr style="background:#034747; color:white;">
              <th style="padding:6px;">Field</th>
              <th style="padding:6px;">Value</th>
            </tr>
          </thead>
          <tbody>
            ${Object.entries(attrs).map(([key, value]) => `
              <tr>
                <td style="border:1px solid #ddd; padding:5px;">
                  <b>${key}</b>
                </td>
                <td style="border:1px solid #ddd; padding:5px;">
                  ${value ?? "-"}
                </td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
    `;
                    }
                }


            }))
        });
        HousingBoardLayerRef.current = HousingBoardURL_layer;
        view.map.add(HousingBoardURL_layer);



        // BDA_URL  ,  BDA_SUBLAYERS
        // const  BDALayerRef = useRef(null);
        // const [ BDALegends, setBDALegends] = useState({});   
        // const [showBDA, setshowBDA] = useState(false);

        const BDAURL_layer = new MapImageLayer({
            url: BDA_URL,
            sublayers: BDA_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,

                popupTemplate: {
                    title: `${s.title} - {col_nm}`,

                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                { fieldName: "objectid", label: "OBJECT ID" },
                                { fieldName: "dist_nm", label: "District Name" },
                                { fieldName: "s_area_nm", label: "Sub Area Name" },
                                { fieldName: "teh_ulb_nm", label: "Tehsil / ULB" },
                                { fieldName: "vill_ward", label: "Village / Ward" },
                                { fieldName: "col_id", label: "Colony ID" },
                                { fieldName: "col_nm", label: "Colony Name" },
                                { fieldName: "ulb_cd", label: "ULB Code" },
                                { fieldName: "dev_authority", label: "Development Authority" },
                                { fieldName: "dist_cd", label: "District Code" },
                        

                              
                                { fieldName: "SHAPE_Area", label: "Area" },
                                { fieldName: "SHAPE_Length", label: "Length" }
                            ]
                        }
                    ],  //  SCROLL ENABLE
                    style: {
                        maxHeight: "350px",
                        overflow: "auto"
                    }
                }
            }))
        });
        BDALayerRef.current = BDAURL_layer;
        view.map.add(BDAURL_layer);


        const New_identified_coloniesURL_layer = new MapImageLayer({
            url: New_identified_coloniesURL,
            sublayers: New_identified_coloniesURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
                popupTemplate: {
                    title: "{colony_name}",
                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                { fieldName: "districtname", label: "District" },
                                { fieldName: "ulbname", label: "ULB" },
                                { fieldName: "wardname", label: "Ward" },
                                { fieldName: "objectid", label: "Object ID" },

                                { fieldName: "colony_name", label: "Colony Name" },
                                { fieldName: "colony_type", label: "Colony Type" },
                                { fieldName: "colony_id", label: "Colony ID" },
                                { fieldName: "gisuniqueid", label: "GIS ID" },

                                { fieldName: "scheme_id", label: "Scheme ID" },
                                { fieldName: "scheme_nm", label: "Scheme Name" },

                                { fieldName: "permission_no", label: "Permission No" },

                                { fieldName: "permission_document", label: "Permission Doc", format: { hyperlink: true } },
                                { fieldName: "layout_photo", label: "Layout Photo", format: { hyperlink: true } },
                                { fieldName: "layout_map_doc", label: "Layout Map", format: { hyperlink: true } }
                            ]
                        }
                    ]
                }

            }))
        });
        New_identified_coloniesURLLayerRef.current = New_identified_coloniesURL_layer;
        view.map.add(New_identified_coloniesURL_layer);

        // DATE : 20 JULY 2026 code for   smartcity_abd_areaURL
        const smartcity_abd_areaURL_layer = new MapImageLayer({
            url: smartcity_abd_areaURL,
            sublayers: smartcity_abd_areaURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
                popupTemplate: {
                    title: "{Smart City ABD}",
                    expressionInfos: [
                        {
                            name: "area_km2",
                            title: "Area (km²)",
                            expression: "$feature.area_sqm / 1000000"
                        }
                    ],
                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                { fieldName: "districtname", label: "District" },
                                { fieldName: "ulbname", label: "ULB Name" },
                                { fieldName: "name", label: "Name" },

                                // ✅ Use expression instead of raw field
                                {
                                    fieldName: "expression/area_km2",
                                    label: "Smart City Area (km²)",
                                    format: {
                                        places: 6,
                                        digitSeparator: true
                                    }
                                }
                            ]
                        }
                    ]
                }
            }))
        });
        smartcity_abd_areaURLLayerRef.current = smartcity_abd_areaURL_layer;
        view.map.add(smartcity_abd_areaURL_layer);


         // DATE :06 AUG 2026 code for   ImportantLandmarks
        const ImportantLandmarksURL_layer = new MapImageLayer({
            url: ImportantLandmarksURL,
            sublayers: ImportantLandmarksURL_sublayer.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr,
                popupEnabled: true,
                popupTemplate: {
                    title: "{ImportantLandmarks}",
                    expressionInfos: [
                        {
                            name: "area_km2",
                            title: "Area (km²)",
                            expression: "$feature.area_sqm / 1000000"
                        }
                    ],
                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                { fieldName: "districtname", label: "District" },
                                { fieldName: "ulbname", label: "ULB Name" },
                                { fieldName: "name", label: "Name" },

                                
                            ]
                        }
                    ]
                }
            }))
        });
        ImportantLandmarksURLLayerRef.current = ImportantLandmarksURL_layer;
        view.map.add(ImportantLandmarksURL_layer);




    }
    // COUNT featureCounts LOAD ALL LAYERS 

    //BHUPENReturn


    return (
        <div>



            {/*CODE FOR UJJAIN   LEFT MENU */}
            <button onClick={() => setOpenPopup(true)} style={{

                backgroundColor: '#031c1a',
                color: '#dbdbe4',
                fontWeight: "bold",
                border: "none",
                borderRadius: "6px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
                transition: "all 0.2s ease"
            }} >
                Full Screen Map
            </button>


            {/* Toggle Popup */}
            <div
                style={{
                    display: UpopupVisible ? "block" : "none",
                    position: "absolute",
                    top: 160,
                    right: '800px',
                    height: "750px",
                    background: "#ffffff",
                    border: "1px solid #ccc",
                    padding: "14px",
                    width: "500px",
                    maxHeight: "85vh",
                    overflowY: "auto",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    borderRadius: "8px",
                    zIndex: 9,
                    opacity: UpopupVisible ? 1 : 0,
                    transform: UpopupVisible ? "translateY(0)" : "translateY(-20px)",
                    transition: "opacity 0.3s ease, transform 0.3s ease, top 0.3s ease"
                }}
            >
                <h3
                    style={{
                        margin: "0 0 10px",
                        padding: "10px",
                        color: "#041836ff",
                        borderRadius: "6px",
                        fontSize: "16px",
                        textAlign: "left"
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "150px",
                            backgroundImage: "url('/img/banner.png')",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "26px",
                            fontWeight: "bold"
                        }}
                    >

                    </div>

                    <center>
                        <h2 style={{ color: "rgb(179, 97, 34)", fontSize: "20px", textAlign: "center" }} >
                            <b>Simhasth 2028 </b>
                        </h2>
                    </center>
                    <p style={{ color: "rgb(179, 97, 34)", fontSize: "20px", textAlign: "center" }}>
                        <button
                            onClick={() => setUPopupVisible(false)}
                            style={{
                                marginTop: "0px",
                                background: "#550101ff",
                                color: "#f0f2f5ff",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                cursor: "pointer",
                                width: "60",
                                float: "right",
                                fontWeight: "bold"
                            }}
                        >
                            Close
                        </button>
                    </p>
                </h3>


                {/* ========= Admin Layers ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={AdminAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = AdminIndeterminate;
                                }}
                                onChange={(e) => toggleAllAdmin(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: AdminSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {AdminAllChecked && "✓"}
                            </span>


                        </label>

                        {/* 👇 TEXT IS NOW PERFECTLY LEFT ALIGNED */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowAdmin(!showAdmin)}
                        >
                            Admin Layers
                        </span>
                    </div>

                    {/* RIGHT SIDE (ARROW) */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowAdmin(!showAdmin)}
                    >
                        {showAdmin ? "▲" : "▼"}
                    </span>
                </h4>


                {showAdmin && (
                    <div>
                        {adminSublayers.map((s) => {
                            const key = `admin-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    secondLayerRef,   // MapImageLayer ref
                                                    "admin",          // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {PropertyLegends[s.id] && (
                                        <img src={PropertyLegends[s.id].image}
                                            alt={PropertyLegends[s.id].label}
                                            style={{ marginLeft: "8px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= PROPERTIES ========= */}


                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={PropertyAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = PropertyIndeterminate;
                                }}
                                onChange={(e) => toggleAllProperty(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: PropertySomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {PropertyAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowProperties(!showProperties)}
                        >
                            '10126mharajwada_to_harsidhi'

                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowProperties(!showProperties)}
                    >
                        {showProperties ? "▲" : "▼"}
                    </span>
                </h4>


                {showProperties && (
                    <div>
                        {PROPERTY_SUBLAYERS.map((s) => {
                            const key = `property-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    PropertierLayerRef, // MapImageLayer ref
                                                    "property",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {PropertyLegends[s.id] && (
                                        <img src={PropertyLegends[s.id].image}
                                            alt={PropertyLegends[s.id].label}
                                            style={{ marginLeft: "8px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Close Layer Panel , setshowSampdaGuideline] = useState(false); */}

                <button
                    onClick={() => setUPopupVisible(false)}
                    style={{
                        marginTop: "12px",
                        background: "#550101ff",
                        padding: "6px 12px",
                        border: "1px solid #ccc",
                        color: "#f6eaeaff",
                        borderRadius: "4px",
                        cursor: "pointer",
                        width: "100%",
                        fontWeight: "bold"
                    }}
                >
                    Close
                </button>
            </div>
            {/*CODE FOR  LEFT MENU */}




            {/* Toggle Button */}
            <button
                onClick={() => setPopupVisible(!popupVisible)}
                style={{
                    position: "absolute",
                    top: 110,
                    right: '0px',
                    width: "140px",          // 🔑 fixed width
                    height: "30px",
                    zIndex: 999,
                    backgroundColor: "#0c7b7bff",
                    border: "1px solid #034747ff",
                    color: "#f4f7fcff",
                    fontWeight: "bold",
                    borderRadius: "6px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                    cursor: "pointer",
                    transition: "all 0.2s ease"
                }}
            >
                {popupVisible ? "Hide Layers" : "Show Layers"}
            </button>

            {/* Toggle Popup */}
            <div
                style={{
                    position: "absolute",
                    top: 160,
                    right: '0px',
                    height: "750px",
                    background: "#ffffff",
                    border: "1px solid #ccc",
                    padding: "14px",
                    width: "280px",
                    maxHeight: "85vh",
                    overflowY: "auto",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    borderRadius: "8px",
                    zIndex: 999999,
                    opacity: popupVisible ? 1 : 0,
                    pointerEvents: popupVisible ? "auto" : "none",
                    transform: popupVisible ? "translateY(0)" : "translateY(-20px)",
                    transition: "opacity 0.3s ease, transform 0.3s ease, top 0.3s ease"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "linear-gradient(to right, #047c6e, #03816c)",
                        padding: "10px 15px",
                        borderRadius: "6px",
                        color: "#fff"
                    }}
                >


                    {/* TITLE */}
                    <h4 style={{ fontSize: "14px", fontWeight: "200" }}>
                        GIS Layer
                    </h4>

                    {/*   handleTabClick(activeTabinfo);  RESET BUTTON */}
                    <button
                        onClick={handleReset}
                        style={{
                            padding: "6px 14px",
                            border: "none",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600",
                            cursor: "pointer",
                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                            color: "#000",
                            transition: "0.3s",
                        }}
                        onMouseOver={(e) => {
                            e.target.style.transform = "translateY(-2px)";
                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                        }}
                        onMouseOut={(e) => {
                            e.target.style.transform = "translateY(0px)";
                            e.target.style.boxShadow = "none";
                        }}
                    >
                        Reset
                    </button>
                </div>

                {/* ========= Admin Layers ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={AdminAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = AdminIndeterminate;
                                }}
                                onChange={(e) => toggleAllAdmin(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: AdminSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {AdminAllChecked && "✓"}
                            </span>


                        </label>

                        {/* 👇 TEXT IS NOW PERFECTLY LEFT ALIGNED */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowAdmin(!showAdmin)}
                        >
                            Admin Layers
                        </span>
                    </div>

                    {/* RIGHT SIDE (ARROW) */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowAdmin(!showAdmin)}
                    >
                        {showAdmin ? "▲" : "▼"}
                    </span>
                </h4>


                {showAdmin && (
                    <div>
                        {adminSublayers.map((s) => {
                            const key = `admin-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    secondLayerRef,   // MapImageLayer ref
                                                    "admin",          // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {PropertyLegends[s.id] && (
                                        <img src={PropertyLegends[s.id].image}
                                            alt={PropertyLegends[s.id].label}
                                            style={{ marginLeft: "8px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= PROPERTIES ========= */}


                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={PropertyAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = PropertyIndeterminate;
                                }}
                                onChange={(e) => toggleAllProperty(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: PropertySomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {PropertyAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowProperties(!showProperties)}
                        >
                            Properties
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowProperties(!showProperties)}
                    >
                        {showProperties ? "▲" : "▼"}
                    </span>
                </h4>


                {showProperties && (
                    <div>
                        {PROPERTY_SUBLAYERS.map((s) => {
                            const key = `property-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    PropertierLayerRef, // MapImageLayer ref
                                                    "property",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {PropertyLegends[s.id] && (
                                        <img src={PropertyLegends[s.id].image}
                                            alt={PropertyLegends[s.id].label}
                                            style={{ marginLeft: "8px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}




                {/* ========= AAI  ========= */}


                { /* Start HEADER*/}
                <h4 style={h4HeaderStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", cursor: "pointer", gap: "6px", }}>
                            <input type="checkbox" checked={AAIAllChecked}
                                ref={(el) => { if (el) el.indeterminate = AAIIndeterminate; }}
                                onChange={(e) => toggleAllAAI(e.target.checked)} style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span style={{
                                width: "20px", height: "20px", border: "2px solid #333", borderRadius: "3px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: AAISomeChecked ? "#4a8dc1ff" : "#fff",
                                color: "#fff", fontSize: "14px",
                            }}>
                                {AAIAllChecked && "✓"}
                            </span> </label>
                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span style={{ cursor: "pointer", fontWeight: "600" }} onClick={() => setshowAAI(!showAAI)}    >
                            Airports Authority of India
                        </span>
                    </div>
                    {/* RIGHT SIDE ARROW */}
                    <span style={{ cursor: "pointer" }} onClick={() => setshowAAI(!showAAI)}>
                        {showAAI ? "▲" : "▼"}  </span>
                </h4>
                { /* Start HEADER*/}
                {showAAI && (
                    <div>
                        {AAI_SUBLAYERS.map((s) => {
                            const key = `AAI-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    AAILayerRef, // MapImageLayer ref
                                                    "AAI",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {AAILegends[s.id] && (
                                        <img src={AAILegends[s.id].image}
                                            alt={AAILegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}
                                    {/*CALL  LAYER VIEW */}



                                    <button
                                        onClick={() => handleViewLayer(AAILayerRef, s,)}
                                        disabled={!checkedLayers[`AAI-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>


                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= Start Monuments  ========= */}


                { /* Start HEADER*/}
                <h4 style={h4HeaderStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", cursor: "pointer", gap: "6px", }}>
                            <input type="checkbox" checked={MonumentsAllChecked}
                                ref={(el) => { if (el) el.indeterminate = MonumentsIndeterminate; }}
                                onChange={(e) => toggleAllMonuments(e.target.checked)} style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span style={{
                                width: "20px", height: "20px", border: "2px solid #333", borderRadius: "3px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: MonumentsSomeChecked ? "#4a8dc1ff" : "#fff",
                                color: "#fff", fontSize: "14px",
                            }}>
                                {MonumentsAllChecked && "✓"}
                            </span> </label>
                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span style={{ cursor: "pointer", fontWeight: "600" }} onClick={() => setshowMonuments(!showMonuments)}    >
                            Archaeological Survey of India
                        </span>
                    </div>
                    {/* RIGHT SIDE ARROW */}
                    <span style={{ cursor: "pointer" }} onClick={() => setshowMonuments(!showMonuments)}>
                        {showMonuments ? "▲" : "▼"}  </span>
                </h4>
                { /* Start HEADER*/}
                {showMonuments && (
                    <div>
                        {Monuments_SUBLAYERS.map((s) => {
                            const key = `Monuments-${s.id}`;
                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    MonumentsLayerRef, // MapImageLayer ref
                                                    "Monuments",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>
                                    {/* {MonumentsLegends[s.id] && (
                                 <image src={MonumentsLegends[s.id].image}  alt={MonumentsLegends[s.id].label}
                                   style={{ marginLeft: "8px", width: "24px", height:"24px" }}
                                        />
                                    )} */}

                                    {MonumentsLegends[s.id] && (
                                        <img src={MonumentsLegends[s.id].image}
                                            alt={MonumentsLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(MonumentsLayerRef, s)}
                                        disabled={!checkedLayers[`Monuments-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>


                                </div>
                            );
                        })}
                    </div>
                )}



                {/* ========= END Monuments  ========= */}

                {/* ========= Start HousingBoard  ========= */}


                { /* Start HEADER*/}
                <h4 style={h4HeaderStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", cursor: "pointer", gap: "6px", }}>
                            <input type="checkbox" checked={HousingBoardAllChecked}
                                ref={(el) => { if (el) el.indeterminate = HousingBoardIndeterminate; }}
                                onChange={(e) => toggleAllHousingBoard(e.target.checked)} style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span style={{
                                width: "20px", height: "20px", border: "2px solid #333", borderRadius: "3px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: HousingBoardSomeChecked ? "#4a8dc1ff" : "#fff",
                                color: "#fff", fontSize: "14px",
                            }}>
                                {HousingBoardAllChecked && "✓"}
                            </span> </label>
                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowHousingBoard(!showHousingBoard)}    >
                            Housing Board
                        </span>
                    </div>
                    {/* RIGHT SIDE ARROW */}
                    <span style={{ cursor: "pointer" }} onClick={() => setshowHousingBoard(!showHousingBoard)}>
                        {showHousingBoard ? "▲" : "▼"}  </span>
                </h4>
                { /* Start HEADER*/}
                {showHousingBoard && (
                    <div>
                        {HousingBoard_SUBLAYERS.map((s) => {
                            const key = `HousingBoard-${s.id}`;
                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    HousingBoardLayerRef, // MapImageLayer ref
                                                    "HousingBoard",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>
                                    {/* {HousingBoardLegends[s.id] && (
                                 <image src={HousingBoardLegends[s.id].image}  alt={HousingBoardLegends[s.id].label}
                                   style={{ marginLeft: "8px", width: "24px", height:"24px" }}
                                        />
                                    )} */}

                                    {HousingBoardLegends[s.id] && (
                                        <img src={HousingBoardLegends[s.id].image}
                                            alt={HousingBoardLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(HousingBoardLayerRef, s)}
                                        disabled={!checkedLayers[`HousingBoard-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>




                                </div>
                            );
                        })}
                    </div>
                )}



                {/* ========= END HousingBoard  ========= */}

                {/* ========= Start BDA  ========= */}


                { /* Start HEADER*/}
                <h4 style={h4HeaderStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", cursor: "pointer", gap: "6px", }}>
                            <input type="checkbox" checked={BDAAllChecked}
                                ref={(el) => { if (el) el.indeterminate = BDAIndeterminate; }}
                                onChange={(e) => toggleAllBDA(e.target.checked)} style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span style={{
                                width: "20px", height: "20px", border: "2px solid #333", borderRadius: "3px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: BDASomeChecked ? "#4a8dc1ff" : "#fff",
                                color: "#fff", fontSize: "14px",
                            }}>
                                {BDAAllChecked && "✓"}
                            </span> </label>
                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowBDA(!showBDA)}    >
                            Development Authorities
                        </span>
                    </div>
                    {/* RIGHT SIDE ARROW */}
                    <span style={{ cursor: "pointer" }} onClick={() => setshowBDA(!showBDA)}>
                        {showBDA ? "▲" : "▼"}  </span>
                </h4>
                { /* Start HEADER*/}
                {showBDA && (
                    <div>
                        {BDA_SUBLAYERS.map((s) => {
                            const key = `BDA-${s.id}`;
                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    BDALayerRef, // MapImageLayer ref
                                                    "BDA",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>
                                    {/* {BDALegends[s.id] && (
                                 <image src={BDALegends[s.id].image}  alt={BDALegends[s.id].label}
                                   style={{ marginLeft: "8px", width: "24px", height:"24px" }}
                                        />
                                    )} */}

                                    {BDALegends[s.id] && (
                                        <img src={BDALegends[s.id].image}
                                            alt={BDALegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(BDALayerRef, s)}
                                        disabled={!checkedLayers[`BDA-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>







                                </div>
                            );
                        })}
                    </div>
                )}



                {/* ========= END BDA  ========= */}
                {/* ========= Start NEW COLONY  ========= */}


                { /* Start HEADER*/}


                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >


                            <input
                                type="checkbox"
                                checked={New_identified_coloniesURLAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = New_identified_coloniesURLIndeterminate;
                                }}
                                onChange={(e) => toggleAllNew_identified_coloniesURL(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: New_identified_coloniesURLSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {New_identified_coloniesURLAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowNew_identified_coloniesURL(!showNew_identified_coloniesURL)}>
                            New Identified Colonies
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowNew_identified_coloniesURL(!showNew_identified_coloniesURL)}
                    >
                        {showNew_identified_coloniesURL ? "▲" : "▼"}
                    </span>
                </h4>

                {showNew_identified_coloniesURL && (
                    <div>
                        {New_identified_coloniesURL_sublayer.map((s) => {
                            const key = `New_identified_colonies-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    New_identified_coloniesURLLayerRef, // layer ref
                                                    "New_identified_colonies",       // group name
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {New_identified_coloniesURLLegends[s.id] && (
                                        <img
                                            src={New_identified_coloniesURLLegends[s.id].image}
                                            alt={New_identified_coloniesURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                    <button
                                        onClick={() => handleViewLayer(New_identified_coloniesURLLayerRef, s)}
                                        disabled={!checkedLayers[`New_identified_colonies-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= END NEW COLONY  ========= */}


                {/* ========= Start smartcity_abd_area  ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >


                            <input
                                type="checkbox"
                                checked={smartcity_abd_areaURLAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = smartcity_abd_areaURLIndeterminate;
                                }}
                                onChange={(e) => toggleAllsmartcity_abd_areaURL(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: smartcity_abd_areaURLSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {smartcity_abd_areaURLAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowsmartcity_abd_areaURL(!showsmartcity_abd_areaURL)}>
                            Smart City
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowsmartcity_abd_areaURL(!showsmartcity_abd_areaURL)}
                    >
                        {showsmartcity_abd_areaURL ? "▲" : "▼"}
                    </span>
                </h4>

                {showsmartcity_abd_areaURL && (
                    <div>
                        {smartcity_abd_areaURL_sublayer.map((s) => {
                            const key = `smartcity_abd_area-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    smartcity_abd_areaURLLayerRef, // layer ref
                                                    "smartcity_abd_area",       // group name
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {smartcity_abd_areaURLLegends[s.id] && (
                                        <img
                                            src={smartcity_abd_areaURLLegends[s.id].image}
                                            alt={smartcity_abd_areaURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                    <button
                                        onClick={() => handleViewLayer(smartcity_abd_areaURLLayerRef, s)}
                                        disabled={!checkedLayers[`smartcity_abd_area-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= END smartcity_abd_area  ========= */}


  {/* ========= Start ImportantLandmarks  ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={ImportantLandmarksURLAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = ImportantLandmarksURLIndeterminate;
                                }}
                                onChange={(e) => toggleAllImportantLandmarksURL(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: ImportantLandmarksURLSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {ImportantLandmarksURLAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowImportantLandmarksURL(!showImportantLandmarksURL)}>
                          Important Landmarks
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowImportantLandmarksURL(!showImportantLandmarksURL)}
                    >
                        {showImportantLandmarksURL ? "▲" : "▼"}
                    </span>
                </h4>

                {showImportantLandmarksURL && (
                    <div>
                        {ImportantLandmarksURL_sublayer.map((s) => {
                            const key = `ImportantLandmarks-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    ImportantLandmarksURLLayerRef, // layer ref
                                                    "ImportantLandmarks",       // group name
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {ImportantLandmarksURLLegends[s.id] && (
                                        <img
                                            src={ImportantLandmarksURLLegends[s.id].image}
                                            alt={ImportantLandmarksURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                    <button
                                        onClick={() => handleViewLayer(ImportantLandmarksURLLayerRef, s)}
                                        disabled={!checkedLayers[`ImportantLandmarks-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= END ImportantLandmarks  ========= */}




                {/* ========= MP LANDUSE ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >


                            <input
                                type="checkbox"
                                checked={mplanduseAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = mplanduseIndeterminate;
                                }}
                                onChange={(e) => toggleAllMPLanduse(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: mplanduseSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {mplanduseAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setShowMPLanduse(!showMPLanduse)}>
                            MP Landuse
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowMPLanduse(!showMPLanduse)}
                    >
                        {showMPLanduse ? "▲" : "▼"}
                    </span>
                </h4>

                {showMPLanduse && (
                    <div>
                        {MPLanduse_sublayer.map((s) => {
                            const key = `mplanduse-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    MPLanduseLayerRef, // layer ref
                                                    "mplanduse",       // group name
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {MPLanduseLegends[s.id] && (
                                        <img
                                            src={MPLanduseLegends[s.id].image}
                                            alt={MPLanduseLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                    <button
                                        onClick={() => handleViewLayer(MPLanduseLayerRef, s)}
                                        disabled={!checkedLayers[`mplanduse-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= MP Land Suitability ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={landsuitabilityAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = landsuitabilityIndeterminate;
                                }}
                                onChange={(e) => toggleAllLandSuitability(e.target.checked)}
                                style={{ display: "none" }}
                            />



                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: landsuitabilitySomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {landsuitabilityAllChecked && "✓"}
                            </span>
                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowLandSuitability(!showLandSuitability)}
                        >
                            Land Suitability
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowLandSuitability(!showLandSuitability)}
                    >
                        {showLandSuitability ? "▲" : "▼"}
                    </span>
                </h4>

                {showLandSuitability && (
                    <div>
                        {LandSuitabilityURL_sublayer.map((s) => {
                            const key = `landsuitability-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    LandSuitabilityURLLayerRef, // layer ref
                                                    "landsuitability",          // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {LandSuitabilityURLLegends[s.id] && (
                                        <img
                                            src={LandSuitabilityURLLegends[s.id].image}
                                            alt={LandSuitabilityURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(LandSuitabilityURLLayerRef, s)}
                                        disabled={!checkedLayers[`landsuitability-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>


                                </div>
                            );
                        })}
                    </div>
                )}


                {/* ========= MP Government ASSETS ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={govtAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = govtIndeterminate;
                                }}
                                onChange={(e) => toggleAllASSETS(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: govtSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {govtAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setGovernmentASSETS(!showGovernmentASSETS)}
                        >
                            Government ASSETS
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setGovernmentASSETS(!showGovernmentASSETS)}
                    >
                        {showGovernmentASSETS ? "▲" : "▼"}
                    </span>
                </h4>

                {showGovernmentASSETS && (
                    <div>
                        {ASSETS_Central_SUBLAYERS.map((s) => {
                            const key = `govtassets-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    ASSETS_CentralLayerRef, // layer ref
                                                    "govtassets",               // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {ASSETS_CentralLegends[s.id] && (
                                        <img
                                            src={ASSETS_CentralLegends[s.id].image}
                                            alt={ASSETS_CentralLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(ASSETS_CentralLayerRef, s)}
                                        disabled={!checkedLayers[`govtassets-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>




                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= MP SBM Swachh Bharat Mission ASSETS ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={sbmAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = sbmIndeterminate;
                                }}
                                onChange={(e) => toggleAllsbm(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: sbmSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {sbmAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowSBM(!showSBM)}
                        >
                            SBM ASSETS
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowSBM(!showSBM)}
                    >
                        {showSBM ? "▲" : "▼"}
                    </span>
                </h4>

                {showSBM && (
                    <div>
                        {SBM_SUBLAYERS.map((s) => {
                            const key = `sbm-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    SMBLayerRef, // layer ref
                                                    "sbm",               // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {SBMLegends[s.id] && (
                                        <img
                                            src={SBMLegends[s.id].image}
                                            alt={SBMLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}





                                    <button
                                        onClick={() => handleViewLayer(SMBLayerRef, s)}
                                        disabled={!checkedLayers[`sbm-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>

                                </div>
                            );
                        })}
                    </div>
                )}
                {/* ========= MP  AMRUT 2.0 Mission ASSETS ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={AMRUTAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = AMRUTIndeterminate;
                                }}
                                onChange={(e) => toggleAllAMRUT(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: AMRUTSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {AMRUTAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowAmrut(!showAmrut)}
                        >
                            AMRUT 2.0
                        </span>
                    </div>

                    {/* BHUPEN AMRUT 2.0 RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowAmrut(!showAmrut)}
                    >
                        {showAmrut ? "▲" : "▼"}
                    </span>
                </h4>

                {showAmrut && (
                    <div>
                        {AMRUT_SUBLAYERS.map((s) => {
                            const key = `AMRUT-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    AMRUTLayerRef, // layer ref
                                                    "AMRUT",               // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        {/* COUNT Feature */}
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {AMRUTLegends[s.id] && (
                                        <img
                                            src={AMRUTLegends[s.id].image}
                                            alt={AMRUTLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}



                                    <button
                                        onClick={() => handleViewLayer(AMRUTLayerRef, s)}
                                        disabled={!checkedLayers[`AMRUT-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= WATER SUPPLY ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={waterAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = waterIndeterminate;
                                }}
                                onChange={(e) => toggleAllWater(e.target.checked)}
                                style={{ display: "none" }}
                            />



                            {/* CUSTOM CHECKBOX UI */}

                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: waterSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {waterAllChecked && "✓"}
                            </span>


                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowWaterSupply(!showWaterSupply)}
                        >
                            Water Supply
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowWaterSupply(!showWaterSupply)}
                    >
                        {showWaterSupply ? "▲" : "▼"}
                    </span>
                </h4>


                {showWaterSupply && (
                    <div>
                        {waterSublayers.map((s) => {
                            const key = `water-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    WaterLayerRef, // layer ref
                                                    "water",       // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {waterLegends?.[s.id] && (
                                        <img
                                            src={waterLegends[s.id].image}
                                            alt={waterLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}



                                    <button
                                        onClick={() => handleViewLayer(WaterLayerRef, s)}
                                        disabled={!checkedLayers[`water-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>





                                </div>
                            );
                        })}
                    </div>
                )}




                {/* ========= STORM WATER ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={stormAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = stormIndeterminate;
                                }}
                                onChange={(e) => toggleAllStorm(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            {/* <input
                                type="checkbox"
                                checked={StormWaterURL_sublayer.every(
                                    (s) => checkedLayers[`storm-${s.id}`]
                                )}
                                onChange={(e) => toggleAllStorm(e.target.checked)}
                                style={{ display: "none" }}
                            /> */}


                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: stormSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {stormAllChecked && "✓"}
                            </span>


                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowStromWater(!showStromWater)}
                        >
                            Storm Water
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowStromWater(!showStromWater)}
                    >
                        {showStromWater ? "▲" : "▼"}
                    </span>
                </h4>
                {showStromWater && (
                    <div>
                        {StormWaterURL_sublayer.map((s) => {
                            const key = `storm-${s.id}`;
                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    StormWaterURLLayerRef, // layer ref
                                                    "storm",               // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {StormWaterURLLegends?.[s.id] && (
                                        <img
                                            src={StormWaterURLLegends[s.id].image}
                                            alt={StormWaterURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(StormWaterURLLayerRef, s)}
                                        disabled={!checkedLayers[`storm-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>



                                </div>
                            );
                        })}
                    </div>
                )}


                {/* ========= WTRB-WATER ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={WTRBAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = WTRBIndeterminate;
                                }}
                                onChange={(e) => toggleAllWTRB(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: WTRBSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {WTRBAllChecked && "✓"}
                            </span>


                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowWTRBWater(!showWTRBWater)}
                        >
                            Water Bodies
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowWTRBWater(!showWTRBWater)}
                    >
                        {showWTRBWater ? "▲" : "▼"}
                    </span>
                </h4>
                {showWTRBWater && (
                    <div>
                        {WTRBWaterURL_sublayer.map((s) => {
                            const key = `WTRB-${s.id}`;
                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    WTRBWaterURLLayerRef, // layer ref
                                                    "WTRB",               // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {WTRBWaterURLLegends?.[s.id] && (
                                        <img
                                            src={WTRBWaterURLLegends[s.id].image}
                                            alt={WTRBWaterURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(WTRBWaterURLLayerRef, s)}
                                        disabled={!checkedLayers[`WTRB-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>



                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= SEWERAGE ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={sewerAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = sewerIndeterminate;
                                }}
                                onChange={(e) => toggleAllSewer(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: sewerSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {sewerAllChecked && "✓"}
                            </span>

                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowSewerage(!showSewerage)}
                        >
                            Sewerage
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowSewerage(!showSewerage)}
                    >
                        {showSewerage ? "▲" : "▼"}
                    </span>
                </h4>


                {showSewerage && (
                    <div>
                        {SEWER_SUBLAYERS.map((s) => {
                            const key = `sewer-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    SEWRAGELayerRef, // layer ref
                                                    "sewer",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {SEWRAGELegends?.[s.id] && (
                                        <img
                                            src={SEWRAGELegends[s.id].image}
                                            alt={SEWRAGELegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                    <button
                                        onClick={() => handleViewLayer(SEWRAGELayerRef, s)}
                                        disabled={!checkedLayers[`sewer-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>





                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= TRANSPORTATION ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE: Checkbox + Label */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                                alignItems: "center",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={transportAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = transportIndeterminate;
                                }}
                                onChange={(e) => toggleAllTransportation(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            {/* CUSTOM CHECKBOX UI */}

                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: transportSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {transportAllChecked && "✓"}
                            </span>


                        </label>

                        {/* LEFT-ALIGNED LABEL */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowTransportation(!showTransportation)}
                        >
                            Transportation
                        </span>
                    </div>

                    {/* RIGHT SIDE: Expand / Collapse */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowTransportation(!showTransportation)}
                    >
                        {showTransportation ? "▲" : "▼"}
                    </span>
                </h4>


                {showTransportation && (
                    <div>
                        {Transportation_SUBLAYERS.map((s) => {
                            const key = `transport-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    TransportationLayerRef, // layer ref
                                                    "transport",            // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {TransportationLegends?.[s.id] && (
                                        <img
                                            src={TransportationLegends[s.id].image}
                                            alt={TransportationLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                    <button
                                        onClick={() => handleViewLayer(TransportationLayerRef, s)}
                                        disabled={!checkedLayers[`transport-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>




                                </div>
                            );
                        })}
                    </div>
                )}

                {/* =========  MASTER Plan ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE: Checkbox + Label */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                                alignItems: "center",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={masterplanAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = masterplanIndeterminate;
                                }}
                                onChange={(e) => toggleAllMasterplan(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: masterplanSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {masterplanAllChecked && "✓"}
                            </span>
                        </label>

                        {/* LEFT-ALIGNED LABEL */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowMasterPlan(!showMasterPlan)}
                        >
                            Master Plan
                        </span>
                    </div>

                    {/* RIGHT SIDE: Expand / Collapse */}
                    <span
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={() => setshowMasterPlan(!showMasterPlan)}
                    >
                        {showMasterPlan ? "▲" : "▼"}
                    </span>
                </h4>

                {showMasterPlan && (
                    <div>
                        {MASTER_PLAN_SUBLAYERS.map((s) => {
                            const key = `masterplan-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    masterPlanLayerRef,
                                                    "masterplan",
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {masterPlanLegends[s.id] && (
                                        <img
                                            src={masterPlanLegends[s.id].image}
                                            alt={masterPlanLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}



                                    <button
                                        onClick={() => handleViewLayer(masterPlanLayerRef, s)}
                                        disabled={!checkedLayers[`masterplan-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>




                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= //  BHUPEN STEP 5  ========= */}

                {/* =========  Green Spaces Plan ========= */}

                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE: Checkbox + Label */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                                alignItems: "center",
                            }}
                        >

                            <input
                                type="checkbox"
                                checked={GreenSpacesAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = GreenSpacesIndeterminate;
                                }}
                                onChange={(e) => toggleAllGreenSpaces(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: GreenSpacesSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {GreenSpacesAllChecked && "✓"}
                            </span>
                        </label>

                        {/* LEFT-ALIGNED LABEL */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowGreenSpaces(!showGreenSpaces)}
                        >
                            Green Spaces
                        </span>
                    </div>

                    {/* RIGHT SIDE: Expand / Collapse */}
                    <span
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={() => setshowGreenSpaces(!showGreenSpaces)}
                    >
                        {showGreenSpaces ? "▲" : "▼"}
                    </span>
                </h4>

                {showGreenSpaces && (
                    <div>
                        {GreenSpacesURL_sublayer.map((s) => {
                            const key = `GreenSpaces-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    GreenSpacesURLLayerRef,
                                                    "GreenSpaces",
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {GreenSpacesURLLegends[s.id] && (
                                        <img
                                            src={GreenSpacesURLLegends[s.id].image}
                                            alt={GreenSpacesURLLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}



                                    <button
                                        onClick={() => handleViewLayer(GreenSpacesURLLayerRef, s)}
                                        disabled={!checkedLayers[`GreenSpaces-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>




                                </div>
                            );
                        })}
                    </div>
                )}




                {/* =========  Sampda Plan ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE: Checkbox + Label */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                                alignItems: "center",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={sampdaAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = sampdaIndeterminate;
                                }}
                                onChange={(e) => toggleAllSampda(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: sampdaSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {sampdaAllChecked && "✓"}
                            </span>
                            {/* CUSTOM CHECKBOX UI */}

                        </label>

                        {/* LEFT-ALIGNED LABEL */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowSampdaGuideline(!showSampdaGuideline)}
                        >
                            SAMPDA Guideline
                        </span>
                    </div>

                    {/* RIGHT SIDE: Expand / Collapse */}
                    <span
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={() => setshowSampdaGuideline(!showSampdaGuideline)}
                    >
                        {showSampdaGuideline ? "▲" : "▼"}
                    </span>
                </h4>


                {showSampdaGuideline && (
                    <div>
                        {SAMPDA_GUIDELINE_SUBLAYERS.map((s) => {
                            const key = `sampda-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    sampdaGuidelineLayerRef,
                                                    "sampda",
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {masterPlanLegends[s.id] && (
                                        <img
                                            src={masterPlanLegends[s.id].image}
                                            alt={masterPlanLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}


                                    <button
                                        onClick={() => handleViewLayer(sampdaGuidelineLayerRef, s)}
                                        disabled={!checkedLayers[`sampda-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>


                                </div>
                            );
                        })}
                    </div>
                )}


                {/* =========  BASEMAP  Plan ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE: Checkbox + Label */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                                alignItems: "center",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={BaseMapAllChecked}
                                ref={(el) => {
                                    if (el) el.indeterminate = BaseMapIndeterminate;
                                }}
                                onChange={(e) => toggleAllBaseMap(e.target.checked)}
                                style={{ display: "none" }}
                            />
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: BaseMapSomeChecked ? "#4a8dc1ff" : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {BaseMapAllChecked && "✓"}
                            </span>

                            {/* CUSTOM CHECKBOX UI */}

                        </label>

                        {/* LEFT-ALIGNED LABEL */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowBaseMap(!showBaseMap)}
                        >
                            BaseMap Layers
                        </span>
                    </div>

                    {/* RIGHT SIDE: Expand / Collapse */}
                    <span
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={() => setshowBaseMap(!showBaseMap)}
                    >
                        {showBaseMap ? "▲" : "▼"}
                    </span>
                </h4>
                {/* //BaseMapURLURL_sublayer   , BasemapLayerRef */}
                {showBaseMap && (
                    <div>
                        {BaseMapURLURL_sublayer.map((s) => {
                            const key = `BaseMap-${s.id}`;
                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    BasemapLayerRef,
                                                    "BaseMap",
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {BasemapLegends[s.id] && (
                                        <img
                                            src={BasemapLegends[s.id].image}
                                            alt={BasemapLegends[s.id].label}
                                            style={{ marginLeft: "5px", marginRight: "5px", width: "24px", height: "24px" }}
                                        />
                                    )}



                                    <button
                                        onClick={() => handleViewLayer(BasemapLayerRef, s)}
                                        disabled={!checkedLayers[`BaseMap-${s.id}`]}
                                        style={{
                                            padding: "6px 14px",
                                            border: "none",
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: "linear-gradient(135deg, #f9d423, #ff4e50)",
                                            color: "#000",
                                            transition: "0.3s",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        View
                                    </button>



                                </div>
                            );
                        })}
                    </div>
                )}
                {/* Close Layer Panel , setshowSampdaGuideline] = useState(false); */}

                <button
                    onClick={() => setPopupVisible(false)}
                    style={{
                        marginTop: "12px",
                        background: "#550101ff",
                        padding: "6px 12px",
                        border: "1px solid #ccc",
                        color: "#f6eaeaff",
                        borderRadius: "4px",
                        cursor: "pointer",
                        width: "100%",
                        fontWeight: "bold"
                    }}
                >
                    Close
                </button>
            </div>




            {
                openPopup && (

                    <div
                        style={{
                            position: "fixed",
                            top: "10px",
                            right: "10px",
                            zIndex: 1000000,
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            width: "250px"
                        }}
                    >

                        {/* Open Popup 1 */}

                        {/* Open Popup 2 */}




                        {/* Close Fullscreen */}
                        <button
                            onClick={() => setOpenPopup(false)}
                            style={{
                                background: "#550101",
                                padding: "8px 12px",
                                border: "none",
                                color: "#fff",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontWeight: "bold"
                            }}
                        >
                            Close Map
                        </button>

                    </div>

                )}



            {/* 23MAY  new info  */}

            {/* 23MAY */}
            <div
                id="DIVFULL"
                ref={mapDiv}
                style={{
                    width: "100%",
                    height: openPopup ? "100vh" : calculatedHeight,
                    borderRadius: "4px",
                    position: openPopup ? "fixed" : "relative",
                    top: openPopup ? 0 : "auto",
                    left: openPopup ? 0 : "auto",
                    zIndex: openPopup ? 999999 : 1,
                    background: "#fff"
                }}
            />


            {/*SEARCH DATA  OVERLAY */}


            {showPopup && (
                <>
                    {/* ✅ BACKGROUND OVERLAY */}
                    <div
                        onClick={() => setShowPopup(false)} // click outside to close
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.5)", // ✅ dim background
                            zIndex: 999999
                        }}
                    />

                    {/* ✅ POPUP MODAL */}
                    <div
                        style={{
                            position: "fixed",
                            bottom: "20%",        // ✅ from bottom
                            left: "50%",          // center horizontally
                            transform: "translateX(-50%)", // center fix
                            width: "1000px",
                            height: "500px",
                            background: "#fff",
                            boxShadow: "0 6px 25px rgba(0,0,0,0.3)",
                            borderRadius: "10px",
                            zIndex: 999999,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden"
                        }}
                    >
                        {/* HEADER */}
                        <div
                            style={{
                                padding: "10px",
                                background: "linear-gradient(to right, #047c6e, #03816c)",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >

                            <center>
                                <div style={{ color: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
                                    <b>Search Data :-</b>: <b>{tableDataLayerRef.label}</b>
                                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "10px" }}>
                                        <div style={{ position: "relative", display: "inline-block" }}>
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                                style={{
                                                    padding: "6px 28px 6px 6px",
                                                    borderRadius: "5px",
                                                    border: "1px solid #ccc"
                                                }}
                                            />

                                            {searchText && (
                                                <span
                                                    onClick={() => setSearchText("")}
                                                    style={{
                                                        position: "absolute",
                                                        right: "8px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        fontWeight: "bold",
                                                        color: "#555"
                                                    }}
                                                >
                                                    ❌
                                                </span>
                                            )}
                                        </div>

                                    </div>
                                    <span>
                                        {(searchText || directorFilter) ? (
                                            <>
                                                Showing <b>{filteredData.length}</b> of <b>{tableData.length}</b>
                                                {directorFilter && <> | Director: <b>{directorFilter}</b></>}
                                                {searchText && <> | Search: <b>{searchText}</b></>}

                                            </>
                                        ) : (
                                            <>Total: <b>{tableData.length}</b></>
                                        )}
                                    </span>

                                </div>

                            </center>


                            <button
                                onClick={downloadExcel}
                                style={{

                                    borderRadius: "4px",
                                    border: "none",
                                    backgroundColor: "#054f71",
                                    color: "#fff",
                                    cursor: "pointer",
                                    marginLeft: "10px"
                                }}
                            >
                                Download Excel
                            </button>

                            <button
                                onClick={() => setShowPopup(false)}
                                style={{
                                    background: "#550101",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",

                                    cursor: "pointer"
                                }}
                            >
                                ✖
                            </button>

                        </div>

                        {/* ✅ SCROLLABLE TABLE */}
                        <div
                            style={{
                                flex: 1,
                                overflow: "auto",
                                padding: "10px"
                            }}
                        >

                            <table
                                style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    backgroundColor: "#f0f9ff",
                                    color: "#0f172a"
                                }}
                            >
                                <thead>
                                    <tr style={{ backgroundColor: "#045e5a", color: "#fff" }}>

                                        {/* ✅ S.No Header */}

                                        <th
                                            style={{
                                                border: "1px solid #151e23",
                                                padding: "8px"
                                            }}
                                        >
                                            S.NO
                                        </th>
                                        <th
                                            style={{
                                                border: "1px solid #151e23",
                                                padding: "8px"
                                            }}
                                        >
                                            LOCATION
                                        </th>

                                        {tableData[0] &&
                                            Object.keys(tableData[0].attributes || {}).map((key) => (
                                                <th
                                                    key={key}
                                                    style={{
                                                        border: "1px solid #151e23",
                                                        padding: "8px",
                                                        textTransform: "uppercase"
                                                    }}
                                                >
                                                    {key}
                                                </th>
                                            ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr
                                                key={index}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? "#e0f2fe" : "#f0f9ff",
                                                    transition: "0.2s",
                                                    cursor: "pointer"
                                                }}
                                                onMouseEnter={(e) =>
                                                    (e.currentTarget.style.backgroundColor = "#bae6fd")
                                                }
                                                onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                    index % 2 === 0 ? "#e0f2fe" : "#f0f9ff")
                                                }
                                            >

                                                {/* ✅ S.No Value */}

                                                <td
                                                    style={{
                                                        border: "1px solid #bae6fd",
                                                        padding: "8px",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    {index + 1}
                                                </td>

                                                <td
                                                    style={{
                                                        border: "1px solid #bae6fd",
                                                        padding: "8px"
                                                    }}
                                                >
                                                    <button
                                                        onClick={() => handleZoom(item)}
                                                        style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "5px",
                                                            border: "none",
                                                            backgroundColor: "#017c68",
                                                            color: "#fff",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        📍 Map
                                                    </button>
                                                </td>
                                                {Object.entries(item.attributes || {}).map(([key, val], i) => {
                                                    let displayValue = val;

                                                    if (key === "area_sqm" && val) {
                                                        displayValue = (val / 1000000).toFixed(2) + " km²";
                                                    }
                                                    return (
                                                        <td
                                                            key={i}
                                                            style={{
                                                                border: "1px solid #bae6fd",
                                                                padding: "8px"
                                                            }}
                                                        >
                                                            {displayValue}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="100%"
                                                style={{
                                                    textAlign: "center",
                                                    padding: "10px",
                                                    border: "1px solid #bae6fd"
                                                }}
                                            >
                                                No results found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </>
            )}
        </div>


    );
};

export default MapGraphDashboad;
